import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  activateViewport,
  getCurrentImage,
  getInitialZoom,
  getViewport,
  loadActiveViewport,
  setInvert,
  FlipHorizontally,
  FlipVertically,
  setToolOnActiveViewport,
  updateViewport,
  checkForLateralSeries,
  changeStack,
  updateOrientationMarkers,
  toggleReferenceLines,
  loadHeatMap,
  loadOutline,
  resizeViewport,
  setRotation,
  setRotationAbsolute,
  getViewportRotation,
  applyViewportStates,
  setStackPosition,
  applyViewportScale,
  getMPRViewport,
  rerenderViewport,
  resetViewPlaneOfCamera,
  performResize,
  resetRotation,
  resetStackPosition,
  getCurrentOuterIndex,
  focusInstanceFrame,
  setUserPreferredCineFps,
  getViewportScaleFactor,
} from "../../helpers/CornerstoneViewportService";
import { startAlignmentLock } from "../../helpers/AlignmentLockService";
import $ from "jquery";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import ImageScrollbar from "../Scrollbar/ImageScrollbar";
import MultiFrameToolbar from "../MultiFrameToolbar/MultiFrameToolbar";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import {
  ACTION_SYNC_MODES,
  DEFAULT_TOOL,
  HP_VIEWPORT_FLIP,
  LATERAL_VIEW_MODALITY_LIST,
  NONXRAYMODALITIES,
  REFLINES_SYNC_EXCLUDED_MODALITIES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  SYNC_EXCLUDED_MODALITIES,
  SYNC_MODES,
  TOAST_TYPE,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import PatientDetails from "../Overlays/PatientDetails";
import StudyDetails from "../Overlays/StudyDetails";
import SeriesDetails from "../Overlays/SeriesDetails";
import CalibrationBadge from "../Overlays/CalibrationBadge";
import DICOMDetails from "../Overlays/DICOMDetails";
import SCDICOMDetails from "../Overlays/SCDICOMDetails";
import ViewportSyncIndicator from "../Overlays/ViewportSyncIndicator";
import ViewportAlignmentLockIndicator from "../Overlays/ViewportAlignmentLockIndicator";
import {
  Enums,
  utilities,
  cache,
  imageLoader,
} from "@cornerstonejs/core";
import {
  StackScrollTool,
  Enums as e,
  annotation
} from "@cornerstonejs/tools";
import MarkWarning from "../Overlays/MarkWarning/MarkWarning";
import {
  resetVOILUTRange,
  setVOILUTRange,
} from "../../helpers/WindowLevelUtility";
import { useTranslation } from "react-i18next";
import OrientationMarkers from "../Overlays/OrientationMarkers";
import TopLoader from "../../../../components/TopLoadingBar/TopLoader";
import loaderContext from "../../../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import { generateSRReport } from "../../helpers/SRModalityService";
import SRReportView from "./SRReportView";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import {
  loadEncapsulatedPDF,
  releaseEncapsulatedPDF,
  buildPdfFileName,
} from "../../helpers/EncapsulatedPDFService";
// Lazy so the pdf.js bundle and its worker are fetched only once a DOC series
// is opened - studies with no encapsulated document never pay for them.
const EncapsulatedPdfViewer = React.lazy(() => import("./EncapsulatedPdfViewer"));
import EncapsulatedDocOverlay from "../Overlays/EncapsulatedDocOverlay";
import { parsePRFile, applyPRToViewport, getAllCachedPREntries, getPRAnnotatedImageIds, isPRPlaced, getPRFrameTargets, imageIdBelongsToSop, reapplyPRViewportState, removePRAnnotationsByUrl, getCachedPRData, buildSpineOverlayLabels } from "../../helpers/PRModalityService";
import { parseKOFile, getAllCachedKOData } from "../../helpers/KOModalityService";
import ViewportNavWidget from "./ViewportNavWidget";
import { publishViewportInstance } from "../../helpers/seriesPanelStore";
import {
  cine
} from "@cornerstonejs/tools/utilities";
import {
  getEngine,
} from "../../helpers/MultiFramePlaybackEngine";
import CINEMinus from "../../../../components/SVGComponents/Tools/CINEMinus";
import CINEPlus from "../../../../components/SVGComponents/Tools/CINEPlus";
import CINEPlaySmall from "../../../../components/SVGComponents/Tools/CINEPlaySmall";
import CINEPauseSmall from "../../../../components/SVGComponents/Tools/CINEPauseSmall";
import Impression from "../../../../components/SVGComponents/Tools/Impression";
import themeContext from "../../../../context/theme/ThemeContext";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../helpers/StackScrollSyncService";
import {
  disableActionSync,
  enableActionSync,
} from "../../helpers/ActionSyncService";
import { isKeyImageAlreadyPresent } from "../../helpers/KeyImageUtility";
import {
  forceReinferenceImage,
  logViewOriginalImage,
} from "../../../../service/StudyViewerService";
import MobileOverlay from "../Overlays/MobileOverlay";
import Draggable from "react-draggable";
import Copy from "../../../../components/SVGComponents/Copy";
import toastContext from "../../../../context/toast/ToastContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import {
  resetOriginalImageState,
  extractSeriesDataFromDragEvent,
} from "../../helpers/ViewerHelperService";
import VDCMobileDetails from "../Overlays/VDCMobileDetails";
import { getToolGroupManager } from "../../helpers/CornerstoneService";
import * as cornerstonetools from "@cornerstonejs/tools";
import Spinner from "../../../../components/Spinner/Spinner";
import { isNonFrontalImagePresent } from "../../helpers/NonFrontalUtility";
import { prefetchData, registerThumbnailStack, replaceThumbnailStack } from "../../helpers/CornerstoneThumbnailService";
import { uploadScDicom } from '../../../../service/StudyViewerService';
import { eventTarget, metaData as cornerstoneMetaData } from "@cornerstonejs/core";
import userContext from "../../../../context/users/UserContext";
import MaskImage from "../Overlays/MaskImage/MaskImage";
import { isImageAllowedToLLM } from "../../../../helpers/CommonUtility";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import { getEnv } from '../../../../helpers/EnvHelper';
import SpineLabellingTool from "../Tools/ToolComponents/SpineLabellingTool";
import DicomOverlayLayer from "../Overlays/DicomOverlayLayer";

const SYNC_TARGET_IMAGE_LOADING_EVENT = "SYNC_TARGET_IMAGE_LOADING";

/**
 * Cornerstone renders a displayArea change on the next frame, so the camera
 * cannot be read back or rotated in the same tick as the alignment write.
 * Nobody sees this wait - it happens behind the hang's curtain.
 */
const HP_CAMERA_SETTLE_MS = 200;

const Viewport = ({ viewportIndex, priors,setInitialVOI }) => {
  const { t } = useTranslation();
  const [viewportElement, setViewportElement] = useState(null);
  const [viewportModality, setViewportModality] = useState("");
  const [viewportProgress, setViewportProgress] = useState(0);
  const [viewportProgressComplete, setViewportProgressComplete] =
    useState(true);
  const [impressionHover, setImpressionHover] = useState(false);
  const [showKeyImageStar, setShowKeyImageStar] = useState(false);
  const {
    studyData,
    studyModality,
    viewportLoading,
    setViewportLoading,
    progress,
    setProgress,
    setProgressComplete,
    impressions,
    keyImages,
    priorStudyKeyImages,
    keyObjectImages,
    priorStudyKeyObjectImages,
    enableHeatmap,
    enableOutline,
    studyParentId,
    priorStudyData,
    studyBoundingBox,
    setAllLoadingComplete,
    sharedViewer,
    nonFrontalImages,
    setForceReinferenceImageIds,
    isHeatMapEnabled,
    setIsHeatMapEnabled,
    isOutlineEnabled,
    setIsOutlineEnabled,
    hpLoading, setHpLoading,
    showPathologyOptions,
    setShowPathologyOptions,
    setViewerOpacity,
    setShowTopBar,
    setShowSharedTopBar,
    hpDataList,
    isHPApplied,
    hpNotFound,
    hpWillHang,

    setMaskImages,
    maskImages,
    cINEFramesPerSecond, setCINEFramesPerSecond,
    reportMenu,
    seriesMenu,
    setReportMenu,
    setSeriesMenu,
    setStudyPRAppliedCount,
    waitForScSeriesAndMerge,
    setPrImages,
    setPriorStudyPRImages,
  } = useContext(studyviewerContext);
  // Keep the multi-frame resolver's fallback FPS in sync with the user's cine
  // preference so it's honoured when a DICOM file carries no rate tags.
  useEffect(() => {
    setUserPreferredCineFps(cINEFramesPerSecond);
  }, [cINEFramesPerSecond]);
  const [viewportLoaded, setViewportLoaded] = useState(false);
  const [scrollImageLoadState, setScrollImageLoadState] = useState({
    loading: false,
    targetIndex: null,
    imageId: null,
  });
  const pendingScrollImageRef = useRef(null);
  const scrollLoaderDelayTimerRef = useRef(null);
  const lastUserScrollSourceRef = useRef({ viewportIndex: null, timestamp: 0 });
  // Tracks the last safeTargetIndex signalled per target viewport so we can
  // skip re-dispatching a loader when the target is already at that index
  // (e.g. source scrolled past boundary, mapping keeps clamping to max).
  const lastSignaledTargetIndexRef = useRef({});

  const clearScrollImageLoader = useCallback(() => {
    pendingScrollImageRef.current = null;
    if (scrollLoaderDelayTimerRef.current) {
      clearTimeout(scrollLoaderDelayTimerRef.current);
      scrollLoaderDelayTimerRef.current = null;
    }
    setScrollImageLoadState((prev) => {
      if (!prev.loading && prev.targetIndex === null && prev.imageId === null) {
        return prev;
      }
      return {
        loading: false,
        targetIndex: null,
        imageId: null,
      };
    });
  }, []);

  const [prAppliedCount, setPrAppliedCount] = useState(0);
  const [prCheckCount, setPrCheckCount] = useState(0);
  // Multi-PR list panel — one entry per PR file available in the study.
  const [prItems, setPrItems] = useState([]); // { url, description, creatorName, date, selected }
  // True while the reactive effect below is still parsing the PR DICOM files for
  // this viewport's study. Used so the PR list popup shows a "Loading…" state
  // instead of the "No PR files" empty state during the async parse window —
  // otherwise a slice that DOES have PRs briefly reads as having none (notably
  // in the priors viewer, where the PR series arrives a beat after navigation).
  const [prItemsLoading, setPrItemsLoading] = useState(false);
  // Mirror of prItems read inside the reactive PR effect — using a ref avoids
  // re-running the effect when the user toggles a PR (toggle handlers already
  // apply/remove imperatively), while still letting the effect respect the
  // latest selection state on slice changes.
  const prItemsRef = useRef([]);
  useEffect(() => { prItemsRef.current = prItems; }, [prItems]);
  // SOP Instance UID of the frame currently visible in the viewport.
  // Updated every time the user scrolls — drives the per-slice PR filter.
  const [currentSopUID, setCurrentSopUID] = useState(null);
  // PR viewport-state (zoom/pan/window) is scoped to the PR's own frame; the user's
  // own view on non-PR frames is tracked by userBaselineRef (declared below). See the
  // reactive PR effect + captureUserBaseline / restoreUserBaseline for the model.
  // Guards our OWN programmatic VOI/camera writes so their VOI_MODIFIED /
  // CAMERA_MODIFIED events aren't mistaken for user interaction.
  const programmaticViewportChangeRef = useRef(false);
  // Timestamp (ms) of the most recent programmatic viewport change. Cornerstone can
  // emit VOI_MODIFIED / CAMERA_MODIFIED asynchronously AFTER our programmatic write has
  // returned (post-render, on a later tick/rAF), so a boolean guard lowered on the next
  // macrotask is not enough. We also treat any VOI/camera event within a short window
  // after a programmatic change as programmatic — otherwise a leaked event captures the
  // PR view as the user's baseline, and the baseline restore on scroll re-shows the PR
  // zoom (the Bug 2 "zoom remains the same on scroll" regression).
  const lastProgrammaticChangeTsRef = useRef(0);
  const PROGRAMMATIC_EVENT_WINDOW_MS = 400;
  const isProgrammaticViewportChange = () =>
    programmaticViewportChangeRef.current ||
    (Date.now() - lastProgrammaticChangeTsRef.current) < PROGRAMMATIC_EVENT_WINDOW_MS;

  // Run a programmatic VOI/camera change with the guard raised. The boolean guard covers
  // synchronous events; the timestamp (stamped before AND after the awaited change)
  // covers Cornerstone's async post-render events via isProgrammaticViewportChange().
  const runProgrammaticViewportChange = async (fn) => {
    programmaticViewportChangeRef.current = true;
    lastProgrammaticChangeTsRef.current = Date.now();
    try {
      return await fn();
    } finally {
      lastProgrammaticChangeTsRef.current = Date.now();
      setTimeout(() => { programmaticViewportChangeRef.current = false; }, 0);
    }
  };

  // ── User "baseline" view (Bug 2) ─────────────────────────────────────────────
  // The zoom / pan / rotation / flip / windowing the USER wants on frames a PR does
  // NOT reference. PR viewport-state is scoped to its own frame: on the PR frame we
  // show the PR view, on every other frame we restore this baseline so the PR's
  // zoom/pan/window never bleeds across the stack. It is seeded when a PR is selected
  // (the pre-PR view) and updated on every manual adjustment, so it always tracks the
  // user's own last view. getViewPresentation() captures zoom/pan RELATIVE to fit
  // (slice-independent), so restoring it can never shift the image plane on a
  // scout-style series where each frame has a different position.
  const userBaselineRef = useRef(null);

  const captureUserBaseline = async () => {
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    try {
      const viewPres = vp.getViewPresentation?.();
      const voiRange = vp.getProperties?.()?.voiRange;
      userBaselineRef.current = {
        viewPres: viewPres ? { ...viewPres } : null,
        voiRange: voiRange ? { ...voiRange } : null,
      };
    } catch (_) {}
  };

  const restoreUserBaseline = async () => {
    const b = userBaselineRef.current;
    if (!b) return;
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    try {
      if (b.voiRange) vp.setProperties({ voiRange: b.voiRange });
      if (b.viewPres) vp.setViewPresentation(b.viewPres);
      vp.render();
    } catch (_) {}
  };

  const [hpSeriesDataLoaded, setHPSeriesDataLoaded] = useState(false);
  const {
    activeViewportIndex,
    changeActiveViewportIndex,
    viewportSeriesData,
    changeViewportSeriesDataUpdated,
    viewportRow,
    viewportColumn,
    addViewportElement,
    viewportElements,
    activeTool,
    mouseButtonToolAssignments,
    previousActiveTool,
    showOverlay,
    setActiveTool,
    setPreviousActiveTool,
    setViewportRow,
    setViewportColumn,
    contextMenuOpen,
    setContextMenuOpen,
    originalImageActiveState,
    editWarning,
    setEditWarning,
    isCineEnabled,
    setIsCineEnabled,
    isSynchronizedEnabled,
    setIsSynchronizedEnabled,
    syncMode,
    actionSyncMode,
    isMPRActive,
    dragEvent,
    setDragEvent,
    activeViewportModality,
    setActiveViewportModality,
    isCompareActive,
    showCompare,
    setShowCompare,
    isReferenceLinesEnabled,
    setIsReferenceLinesEnabled,
    disableAddPathology,
    setDisableAddPathology,
    setAllowAddingTextAnnotation,
    setOriginalImageActiveState,
    isReferenceLineActivated,
    setIsReferenceLineActivated,
    setImageLoadedOnViewport,
    updateBBPosition,
    setViewportLoadingComplete,
    handleDefaultToolChange,
    isScrollingUp,
    setIsScrollingUp,
    viewportHpLayout,
    viewportHpImage,
    hpApplyToken,
    markHpViewportApplied,
    viewportOldState,
    setViewportOldState,
    updateViewportProperties,
    viewportStates,
    viewportDoubleClickIndex, setViewportDoubleClickIndex,
    viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst,
    handleRemoveWarning,
    boundingBoxAdding, setBoundingBoxAdding,
    isSrSelected, setIsSrSelected, 
    isCropEnable, maskingConfirm, setMaskingConfirm,
    disableMasking,
    isAutoLoadLayout, setIsAutoLoadLayout,
    linkedViewports, setLinkedViewports,
    alignmentLocks,
    isSpineLabellingActive,
    spineLabels,
    setSpineLabels,
    markViewportImageLoaded,
  } = useContext(ViewportContext);

  // Publish this viewport's real load state; the cleanup covers the layout
  // unmounting the slot (2x2 -> 1x1 -> 2x2), which drops the image while
  // viewportSeriesData still holds the old series.
  useEffect(() => {
    markViewportImageLoaded(viewportIndex, viewportLoaded);
    return () => markViewportImageLoaded(viewportIndex, false);
  }, [viewportIndex, viewportLoaded, markViewportImageLoaded]);

  const {
    activeThumbnailIndex,
    changeActiveThumbnailIndex,
    activeThumbnailData,
    lateralThumbnailIndex,
    activeModality,
    setActiveModality,
    setActiveStudyId,
    thumbnailLoadingComplete,
    setLateralThumbnailIndex,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);

  const { setAlertSuccessModal, 
    alertSuccessModal, 
    setForReinferenceInProgress,
    reportDoneStatusState,
    usgAgentEnabled, reportingDoctorName, isWordFilePath ,
    studyDescription,
    refreshScDicomLibrary,
    markPendingCapture,
    activeTabKey,
  } = useContext(studyReportContext);

  const {isAgenticTab} = useContext(AgenticReportingContext);
  const {enableLlmReport} = useContext(userContext);
  const { theme } = useContext(themeContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [srReport, setSRReport] = useState(null);
  // Encapsulated PDF (modality DOC) state. pdfDocument holds the object URL the
  // browser's PDF viewer renders plus the DICOM metadata the patient information
  // overlay shows; the URL is owned by this viewport and revoked when replaced.
  const [pdfDocument, setPdfDocument] = useState(null);
  const [pdfError, setPdfError] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [imageCount, setImageCount] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewportData, setViewportData] = useState(activeThumbnailData);
  const [thumbnailId, setThumbnailId] = useState();
  const [voi, setVOI] = useState({ windowCenter: null, windowWidth: null });
  const [scale, setScale] = useState(1);
  const [initialVOIRange, setInitialVOIRange] = useState({});
  const [markers, setMarkers] = useState({});
  const elementRef = useRef(null);
  const impressionRef = useRef(null);
  const draggableRef = useRef(null);
  const [scrollbarHeight, setScrollbarHeight] = useState("100px");
  const [isActivated, setIsActivated] = useState(false);
  // Settles once cornerstone has this viewport enabled; loadViewport waits on it.
  const activationRef = useRef(null);
  const [viewportLevelCINEEnabled, setViewportLevelCINEEnabled] =
    useState(true);
  const [viewportRendered, setViewportRendered] = useState(false);
  // Counts completed series loads into this viewport, so an alignment lock knows
  // when there is a fresh, freshly-centred image to re-pin. See loadViewport.
  const [viewportLoadEpoch, setViewportLoadEpoch] = useState(0);
  const { showToastv2 } = useContext(toastContext);
  const [viewportLoaderRunning, setViewportLoaderRunning] = useState(true);
  const [showForceReinference, setShowForceReinference] = useState(false);
  const [nonFrontalImageId, setNonFrontalImageId] = useState(null);
  const [viewportFocusCalled, setViewportFocusCalled] = useState(false);
  // The "image as a line" hack further down resets pan/zoom/centre once the
  // image has rendered. A hanging protocol's alignment, rotation and zoom have
  // to be written AFTER that reset or it wipes them, so the hang waits on this.
  const [viewportCameraSettled, setViewportCameraSettled] = useState(false);
  const {roles, username, userId} = useContext(userContext);

  const setScrollLoaderForIndex = useCallback((targetIndex, imageIdsOverride = null, forcePending = false) => {
    const seriesImageIds = imageIdsOverride || viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      clearScrollImageLoader();
      return;
    }

    const safeTargetIndex = Math.max(0, Math.min(targetIndex, seriesImageIds.length - 1));
    const imageId = seriesImageIds[safeTargetIndex];

    if (!imageId) {
      clearScrollImageLoader();
      return;
    }

    if (!forcePending && !!cache.getImage(imageId)) {
      clearScrollImageLoader();
      return;
    }

    pendingScrollImageRef.current = {
      viewportIndex,
      targetIndex: safeTargetIndex,
      imageId,
    };

    if (scrollLoaderDelayTimerRef.current) {
      clearTimeout(scrollLoaderDelayTimerRef.current);
    }

    scrollLoaderDelayTimerRef.current = setTimeout(() => {
      // Re-check cache at trigger time because image may have loaded during
      // debounce window; in that case avoid showing a stale loader.
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
        scrollLoaderDelayTimerRef.current = null;
        return;
      }

      setScrollImageLoadState((prev) => {
        if (prev.loading && prev.imageId === imageId) {
          return prev;
        }
        return {
          loading: true,
          targetIndex: safeTargetIndex,
          imageId,
        };
      });
      scrollLoaderDelayTimerRef.current = null;
    }, 80);
  }, [clearScrollImageLoader, viewportIndex, viewportSeriesData]);

  const [clippedStudyImages, setClippedStudyImages] = useState([]);
  const [viewportRotation, setViewportRotation] = useState(0);
  const viewportRef = useRef(null);
  const rightClickTimer = useRef(null);
  const isDragging = useRef(false);
  const rightClickThreshold = 400; 

  const updateKeyImageStar = async () => {
    const viewport = await getViewport(viewportIndex);
    if (
      viewport &&
      viewport.imageIds.length != 0 &&
      (isKeyImageAlreadyPresent(viewport, keyImages) ||
        isKeyImageAlreadyPresent(viewport, keyObjectImages) ||
        (priors && (isKeyImageAlreadyPresent(viewport, priorStudyKeyImages) ||
          isKeyImageAlreadyPresent(viewport, priorStudyKeyObjectImages))))
    ) {
      setShowKeyImageStar(true);
    } else {
      setShowKeyImageStar(false);
    }
  };

  const updateNonFrontalButton = async () => {
    const viewport = await getViewport(viewportIndex);

    if (viewport && viewport.imageIds.length != 0) {
      if (
        isNonFrontalImagePresent(
          viewport,
          nonFrontalImages,
          setNonFrontalImageId
        )
      ) {
        setShowForceReinference(true);
      } else {
        setShowForceReinference(false);
      }
    }
  };

  // updateNonFrontalButton is otherwise only invoked from the STACK_NEW_IMAGE
  // handler below. nonFrontalImages loads asynchronously from the study API
  // and often arrives after that event has already fired for the initially
  // displayed image — without this effect, a chest study whose default view
  // is the flagged non-frontal image never gets its button state recomputed
  // until the user manually navigates the stack.
  useEffect(() => {
    if (viewportLoaded) {
      updateNonFrontalButton();
    }
  }, [nonFrontalImages, viewportLoaded]);

  const signalSyncTargetLoaders = useCallback((sourceIndex) => {
    if (!isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    const sourceImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    const sourceLength = sourceImageIds.length;

    if (sourceLength <= 1) {
      return;
    }

    const sourceStudy = viewportSeriesData?.[viewportIndex]?.study;
    let targetViewportIndices = viewportSeriesData
      .map((data, idx) => ({ data, idx }))
      .filter(({ data, idx }) => idx !== viewportIndex && data?.stack && data.stack !== "")
      .map(({ idx }) => idx);

    if (syncMode === SYNC_MODES.AUTOMATIC && sourceStudy) {
      targetViewportIndices = targetViewportIndices.filter(
        (idx) => viewportSeriesData?.[idx]?.study === sourceStudy
      );
    }

    if (linkedViewports.length > 0) {
      targetViewportIndices = targetViewportIndices.filter((idx) => linkedViewports.includes(idx));
    }

    targetViewportIndices.forEach((targetViewportIdx) => {
      const targetImageIds = viewportSeriesData?.[targetViewportIdx]?.stack?.thumbnailImageIds || [];

      if (targetImageIds.length <= 1) {
        eventTarget.dispatchEvent(
          new CustomEvent(SYNC_TARGET_IMAGE_LOADING_EVENT, {
            detail: {
              viewportIndex: targetViewportIdx,
              loading: false,
            },
          })
        );
        return;
      }

      const mappedIndex = Math.round((sourceIndex / (sourceLength - 1)) * (targetImageIds.length - 1));
      const safeTargetIndex = Math.max(0, Math.min(mappedIndex, targetImageIds.length - 1));

      // If the target index hasn't changed since the last signal, the target
      // viewport is already at that frame (e.g. source scrolled past boundary
      // and the index keeps clamping to min/max).  No navigation will happen
      // so there is nothing to show a loader for.
      if (lastSignaledTargetIndexRef.current[targetViewportIdx] === safeTargetIndex) {
        return;
      }
      lastSignaledTargetIndexRef.current[targetViewportIdx] = safeTargetIndex;

      const targetImageId = targetImageIds[safeTargetIndex];

      eventTarget.dispatchEvent(
        new CustomEvent(SYNC_TARGET_IMAGE_LOADING_EVENT, {
          detail: {
            viewportIndex: targetViewportIdx,
            targetIndex: safeTargetIndex,
            imageId: targetImageId,
            loading: !!targetImageId,
          },
        })
      );

      // Priority-download the target image into cache without navigating
      // the viewport.  This avoids triggering STACK_VIEWPORT_SCROLL on the
      // target, which would cause the Cornerstone bidirectional synchronizer
      // to echo back and hang the source scrollbar.
      // The existing IMAGE_LOADED handler on the target viewport will
      // navigate and clear the loader once the image is ready.
      if (targetImageId && !cache.getImage(targetImageId)) {
        imageLoader.loadAndCacheImage(targetImageId).catch(() => {});
      }
    });
  }, [
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportIndex,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (viewportLoaded) {
      updateKeyImageStar();
    }
  }, [keyImages, keyObjectImages, viewportLoaded]);

  const updateForceReinferenceImageIds = (nonFrontalImages) => {
    const foundObject = nonFrontalImages.find(obj => obj.imageId === nonFrontalImageId);
      if (foundObject) {
        const imageUrl = foundObject.imageUrl;
        setForceReinferenceImageIds(prevState => [...prevState, imageUrl]);
      }
  }

  const forceReinference = async () => {
    const response = await forceReinferenceImage(
      studyParentId,
      nonFrontalImageId
    );
    if (response.status === 200) {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = true;
        newItem.isWarning = false;
        newItem.description = t("viewer.tools.force-reinference-success");
        return newItem;
      });
    } else {
      setForReinferenceInProgress(true);
      updateForceReinferenceImageIds(nonFrontalImages);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = true;
        newItem.isSuccess = false;
        newItem.isWarning = false;
        newItem.description = response.data.message;
        return newItem;
      });
    }
  };

  useEffect(() => {
    if (viewportIndex !== 0) return;
    if (
      activeViewportIndex / VIEWPORT_COLUMN >= viewportRow ||
      activeViewportIndex % VIEWPORT_COLUMN >= viewportColumn
    ) {
      setActive();
    }
  }, [viewportColumn, viewportRow]);

  useEffect(() => {
    const getOrientationMarkers = async (event) => {
      const m = await updateOrientationMarkers(
        event,
        "viewport_" + viewportIndex
      );
      setMarkers(m);
      // updateKeyImageStar();
      updateNonFrontalButton();

      const viewport = await getViewport(viewportIndex);
      const currentImageIndex = viewport.getCurrentImageIdIndex();

      // Mixed-series two-axis: during cine the viewport's imageIdIndex is
      // the FRAME of the active instance; the scrollbar should keep
      // showing the OUTER (per-instance) position. getCurrentOuterIndex
      // returns the pinned outer idx for mixed-series viewports and null
      // otherwise (in which case we fall back to the viewport's own idx).
      // For single-instance multiframe viewports (engine exists, no outer
      // index), skip setCurrentImage entirely — the scrollbar max is 0 so
      // the only valid position is 0, and updating currentImage to the
      // current frame index would break callers that index into stack.images.
      const outerIdx = getCurrentOuterIndex("viewport_" + viewportIndex);
      if (outerIdx != null) {
        setCurrentImage(outerIdx);
      } else if (!getEngine("viewport_" + viewportIndex)) {
        setCurrentImage(viewport.getCurrentImageIdIndex());
      }
      // Trigger PR check on every new image display — including series switch
      // where currentImage stays 0 and the normal state-change bail-out skips it.
      setPrCheckCount((c) => c + 1);

      const imageIds = viewport?.getImageIds?.() || [];
      const currentImageId = imageIds[currentImageIndex];

      // If current image is already available, loader should not remain active.
      if (currentImageId && cache.getImage(currentImageId)) {
        clearScrollImageLoader();
      }

      if (
        pendingScrollImageRef.current?.viewportIndex === viewportIndex &&
        pendingScrollImageRef.current?.targetIndex === currentImageIndex
      ) {
        clearScrollImageLoader();
      }

      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex !== null &&
        isReferenceLineActivated
      ) {
        setIsReferenceLinesEnabled(true);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_NEW_IMAGE,
        getOrientationMarkers
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_NEW_IMAGE,
          getOrientationMarkers
        );
      };
    }
  }, [viewportElement, nonFrontalImages, clearScrollImageLoader]);

  useEffect(() => {
    const onWheelStart = async (event) => {
      const deltaY = event?.deltaY;
      if (typeof deltaY !== "number" || deltaY === 0) {
        return;
      }

      lastUserScrollSourceRef.current = {
        viewportIndex,
        timestamp: Date.now(),
      };

      const viewport = await getViewport(viewportIndex);
      if (!viewport) {
        return;
      }

      const viewportImageIds = viewport?.getImageIds?.() || [];
      const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
      const imageIds = viewportImageIds.length > 0 ? viewportImageIds : seriesImageIds;

      if (!Array.isArray(imageIds) || imageIds.length === 0) {
        return;
      }

      const currentIndex = viewport.getCurrentImageIdIndex();
      if (typeof currentIndex !== "number") {
        return;
      }

      const direction = deltaY > 0 ? 1 : -1;
      const nextIndex = Math.max(0, Math.min(currentIndex + direction, imageIds.length - 1));
      const imageId = imageIds[nextIndex];
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
      } else {
        setScrollLoaderForIndex(nextIndex, imageIds);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener("wheel", onWheelStart, { passive: true });

      return () => {
        viewportElement?.removeEventListener("wheel", onWheelStart);
      };
    }
  }, [
    viewportElement,
    viewportIndex,
    viewportSeriesData,
    setScrollLoaderForIndex,
  ]);

  useEffect(() => {
    const updateImageIndex = async () => {
      const viewport = await getViewport(viewportIndex);
      const currentIndex = viewport.getCurrentImageIdIndex();

      // See getOrientationMarkers above — same reason: during cine the
      // scrollbar must reflect outer instance position, not the frame
      // index of the active multi-frame instance. For single-instance
      // multiframe, skip entirely (engine exists, no outer index).
      const outerIdx = getCurrentOuterIndex("viewport_" + viewportIndex);
      if (outerIdx != null) {
        setCurrentImage(outerIdx);
      } else if (!getEngine("viewport_" + viewportIndex)) {
        setCurrentImage(viewport.getCurrentImageIdIndex());
      }

      const recentlyUserScrolledThisViewport =
        lastUserScrollSourceRef.current?.viewportIndex === viewportIndex &&
        Date.now() - (lastUserScrollSourceRef.current?.timestamp || 0) < 450;

      if (
        isSynchronizedEnabled &&
        syncMode !== SYNC_MODES.DISABLED &&
        (viewportIndex === activeViewportIndex || recentlyUserScrolledThisViewport)
      ) {
        signalSyncTargetLoaders(currentIndex);
      }

      const viewportImageIds = viewport?.getImageIds?.() || [];
      const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
      const imageIds = viewportImageIds.length > 0 ? viewportImageIds : seriesImageIds;
      const imageId = imageIds[currentIndex];
      if (imageId && cache.getImage(imageId)) {
        clearScrollImageLoader();
      } else {
        setScrollLoaderForIndex(currentIndex, imageIds);
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.STACK_VIEWPORT_SCROLL,
        updateImageIndex
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.STACK_VIEWPORT_SCROLL,
          updateImageIndex
        );
      };
    }
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    setScrollLoaderForIndex,
    signalSyncTargetLoaders,
    syncMode,
    viewportElement,
    viewportIndex,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (!viewportLoaded) {
      return;
    }

    if (typeof currentImage !== "number") {
      return;
    }

    const seriesImageIds = viewportSeriesData?.[viewportIndex]?.stack?.thumbnailImageIds || [];
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      return;
    }

    setScrollLoaderForIndex(currentImage, seriesImageIds);
  }, [
    currentImage,
    viewportLoaded,
    viewportIndex,
    viewportSeriesData,
    setScrollLoaderForIndex,
  ]);

  useEffect(() => {
    if (!scrollImageLoadState.loading || !scrollImageLoadState.imageId) {
      return;
    }

    const onImageLoaded = async (event) => {
      const loadedImageId = event?.detail?.image?.imageId;
      const pending = pendingScrollImageRef.current;
      if (!pending || loadedImageId !== pending.imageId) {
        return;
      }

      // Navigate only if Cornerstone's synchronizer hasn't already put us
      // at the correct frame.  During partial downloads the synchronizer
      // cannot map to the target slice (no metadata yet), so we must
      // navigate manually.  During fast scrolling only the LAST pending
      // image matches here, so at most one updateViewport fires — this
      // avoids the rapid-fire echo-back that previously caused scroll hang.
      try {
        const viewport = await getViewport(viewportIndex);
        const currentIndex = viewport?.getCurrentImageIdIndex?.();
        if (
          typeof pending.targetIndex === "number" &&
          typeof currentIndex === "number" &&
          currentIndex !== pending.targetIndex
        ) {
          await updateViewport(viewportIndex, pending.targetIndex);
        }
      } catch (e) {
        // Viewport may have been destroyed between event and handler
      }

      clearScrollImageLoader();
    };

    eventTarget.addEventListener(Enums.Events.IMAGE_LOADED, onImageLoaded);
    return () => {
      eventTarget.removeEventListener(Enums.Events.IMAGE_LOADED, onImageLoaded);
    };
  }, [scrollImageLoadState.loading, scrollImageLoadState.imageId, clearScrollImageLoader, viewportIndex]);

  useEffect(() => {
    const onSyncTargetImageLoading = (event) => {
      const detail = event?.detail || {};

      if (detail.viewportIndex !== viewportIndex) {
        return;
      }

      if (!detail.loading) {
        clearScrollImageLoader();
        return;
      }

      // If the image is already in Cornerstone's cache, just clear the loader.
      // Do NOT navigate the viewport — Cornerstone's synchronizer handles that.
      // Navigating here would trigger STACK_VIEWPORT_SCROLL echo-back through
      // the bidirectional synchronizer and hang the source's mouse scroll.
      if (detail.imageId && cache.getImage(detail.imageId)) {
        clearScrollImageLoader();
        return;
      }

      pendingScrollImageRef.current = {
        viewportIndex,
        targetIndex: detail.targetIndex,
        imageId: detail.imageId,
      };

      // Cancel any lingering debounce timer from a previous scroll event.
      if (scrollLoaderDelayTimerRef.current) {
        clearTimeout(scrollLoaderDelayTimerRef.current);
        scrollLoaderDelayTimerRef.current = null;
      }

      // Show the loader immediately for sync targets so the brief blank frame
      // that Cornerstone renders while loading an uncached image is hidden by
      // the overlay rather than visible to the user (prevents flickering).
      setScrollImageLoadState((prev) => {
        if (prev.loading && prev.imageId === detail.imageId) {
          return prev;
        }
        return {
          loading: true,
          targetIndex: detail.targetIndex,
          imageId: detail.imageId,
        };
      });
    };

    eventTarget.addEventListener(SYNC_TARGET_IMAGE_LOADING_EVENT, onSyncTargetImageLoading);
    return () => {
      eventTarget.removeEventListener(SYNC_TARGET_IMAGE_LOADING_EVENT, onSyncTargetImageLoading);
    };
  }, [viewportIndex, clearScrollImageLoader]);

  useEffect(() => {
    return () => {
      if (scrollLoaderDelayTimerRef.current) {
        clearTimeout(scrollLoaderDelayTimerRef.current);
      }
    };
  }, []);


   
  const loadAIOutlineAndHeatmap = async (overlayStacks = null) => {
    const viewportSeries = viewportSeriesData?.[viewportIndex];
    const fallbackThumbnailIndex =
      viewportSeries?.thumbnailIndex ?? activeThumbnailIndex;
    // Prefer the modality passed explicitly via overlayStacks. handleDrop calls this
    // synchronously (through loadSeriesIntoViewport) right after kicking off the
    // viewportSeriesData/activeModality state updates for the JUST-dropped series -
    // those updates haven't committed yet, so viewportSeries?.modality/activeModality
    // here would still read the PREVIOUS series' modality (e.g. a prior CT) instead
    // of the new one, wrongly gating the overlay off for a valid X-ray drop.
    const normalizedActiveModality = (
      overlayStacks?.modality || viewportSeries?.modality || activeModality || ""
    )
      .toString()
      .trim()
      .toUpperCase();
    const explicitHeatmapIds = overlayStacks?.heatmapStack?.imageIds;
    const explicitOutlineIds = overlayStacks?.outlineStack?.imageIds;
    const viewportHeatmapIds =
      explicitHeatmapIds ||
      viewportSeries?.heatmapStack?.imageIds ||
      studyData?.heatmapStacks?.[fallbackThumbnailIndex]?.imageIds;
    const viewportOutlineIds =
      explicitOutlineIds ||
      viewportSeries?.outlineStack?.imageIds ||
      studyData?.outlineStacks?.[fallbackThumbnailIndex]?.imageIds;

    if (!SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(normalizedActiveModality)) {
      return;
    }

    // await resizeViewport();
    await rerenderViewport();
    loadHeatMap(
      viewportHeatmapIds,
      isHeatMapEnabled,
      viewportIndex
    );
    // await resizeViewport();
    await rerenderViewport();
    loadOutline(
      viewportOutlineIds,
      isOutlineEnabled,
      viewportIndex
    );
  };

  useEffect(() => {
    const enableReferenceLine = async (event) => {
      if (
        viewportIndex === 1 &&
        LATERAL_VIEW_MODALITY_LIST.includes(studyModality) &&
        lateralThumbnailIndex != null &&
        isReferenceLineActivated
      ) {
        setTimeout(() => {
          setIsReferenceLinesEnabled(true);
        }, 1000);
      }
    };

    if (
      viewportElement !== null &&
      viewportIndex == 1 &&
      !isReferenceLinesEnabled
    ) {
      viewportElement?.addEventListener(
        Enums.Events.IMAGE_RENDERED,
        enableReferenceLine
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.IMAGE_RENDERED,
          enableReferenceLine
        );
      };
    }
  }, [viewportElement]);




  // useEffect(() => {
  //   const stopLoader = async (event) => {
  //     console.log("IMAGE RENDERED");
  //     console.log(event);
  //     if (event.detail.viewportStatus === "rendered") {
  //       setViewportLoaderRunning(false);
  //     }
  //   };

  //   if (viewportElement !== null) {
  //     viewportElement?.addEventListener(
  //       Enums.Events.IMAGE_RENDERED,
  //       stopLoader
  //     );

  //     return () => {
  //       viewportElement?.removeEventListener(
  //         Enums.Events.IMAGE_RENDERED,
  //         stopLoader
  //       );
  //     };
  //   }
  // }, [viewportElement]);

  useEffect(() => {
    loadAIOutlineAndHeatmap();
  }, [currentImage, isHeatMapEnabled, isOutlineEnabled]);

  // Note: the series scrollbar position is driven entirely by `currentImage`,
  // which the STACK_NEW_IMAGE handlers keep pinned to the OUTER (per-instance)
  // index during cine (getCurrentOuterIndex) and leave untouched for
  // single-instance multiframe. No separate "freeze while playing" subscription
  // is needed — the old one captured a stale currentImage and snapped the
  // scrollbar to the top during playback.

  // Tell the series panel which instance this viewport shows, so the expanded
  // series' instance tiles can highlight it. currentImage is the series-level
  // (outer) index — for a series of cine clips, the clip, not the frame.
  useEffect(() => {
    publishViewportInstance(
      viewportIndex,
      viewportSeriesData[viewportIndex]?.thumbnailIndex,
      currentImage
    );
  }, [viewportIndex, currentImage, viewportSeriesData]);

  // SOP of the instance the reactive PR apply last saw — see enteredNewInstance.
  const lastFocusedSopRef = useRef(null);

  /**
   * Bring the viewport to the frame a multi-frame PR is scoped to, paused.
   * `onlySop` limits it to targets on that instance (the one being entered).
   * No-op for PRs that name no frame (single-frame images / "all frames").
   */
  const focusPRFrame = async (prData, onlySop = null) => {
    const targets = getPRFrameTargets(prData)
      .filter((t) => !onlySop || t.sop === onlySop);
    for (const { sop, frameNumber } of targets) {
      const ok = await focusInstanceFrame(
        viewportIndex,
        (id) => imageIdBelongsToSop(id, sop),
        frameNumber - 1
      );
      if (ok) return true;
    }
    return false;
  };

  // Reactive PR apply: when a frame becomes active its metadata is now loaded,
  // so we can match it against any cached PR that references it by SOP UID.
  useEffect(() => {
    if (!viewportLoaded) return;
    const applyPRForCurrentFrame = async () => {
      const vp = await getViewport(viewportIndex);
      if (!vp) return;
      const imageId = vp.getCurrentImageId();
      if (!imageId) return;

      // Only match by exact SOP UID from metadata — URL substring matching
      // causes false positives because one DICOM UID is a prefix of another.
      const meta = cornerstoneMetaData.get("sopCommonModule", imageId);
      const sopUID = (meta?.sopInstanceUID ?? meta?.SOPInstanceUID)?.trim();

      // Always update the current-slice SOP UID so the PR list panel filters correctly.
      setCurrentSopUID(sopUID || null);

      if (!sopUID) return;

      const allPREntries = getAllCachedPREntries();
      const currentStack = viewportSeriesData[viewportIndex]?.stack;

      // Auto-open is OFF (bug 8): only apply PRs the user has EXPLICITLY selected
      // in the list panel. A PR not yet in prItems, or with selected !== true, is
      // treated as not selected — so nothing is auto-applied on study open.
      const selectedUrls = new Set(
        prItemsRef.current.filter((i) => i.selected === true).map((i) => i.url)
      );

      // Find the first SELECTED PR that references the current frame.
      let matchedPR = null;
      let matchedPRUrl = null;
      for (const { url, data } of allPREntries) {
        if (!selectedUrls.has(url)) continue;
        if (data.referencedSOPInstanceUIDs?.some((u) => u?.trim() === sopUID)) {
          matchedPR = data;
          matchedPRUrl = url;
          break;
        }
      }

      // PR viewport-state is scoped to its OWN frame: show the PR view only on the
      // frame the PR references, and the user's baseline view on every other frame.
      const prModeActive = selectedUrls.size > 0;

      // Entering a different instance resets the "already landed" marker, so a
      // multi-frame PR's frame is jumped to once per visit — never while the user
      // plays / scrubs through the same clip.
      const enteredNewInstance = lastFocusedSopRef.current !== sopUID;
      lastFocusedSopRef.current = sopUID;

      if (matchedPR) {
        // Ensure a baseline exists (the user's pre-PR view) BEFORE we override the
        // viewport with the PR view — otherwise scrolling off this frame would have
        // nothing to restore and the PR zoom would persist across the stack (Bug 2).
        // Safe: at this instant the viewport still shows the user's own view (the PR
        // view is applied on the lines below), not the PR's.
        if (!userBaselineRef.current) await captureUserBaseline();

        // On a PR-referenced image (any frame of a clip): place annotations if not yet
        // placed — each lands on its own referenced frame — and (re)apply the PR's
        // viewport state every time we ENTER the image so the PR view is always shown
        // on it, regardless of the user's baseline. Guard the programmatic writes so
        // their VOI/CAMERA events aren't misread as user input.
        const alreadyAnnotated =
          getPRAnnotatedImageIds().has(imageId) || isPRPlaced(matchedPRUrl);
        if (enteredNewInstance) {
          // Multi-frame PR: land on the frame it was drawn on (Advance Viewer parity).
          await runProgrammaticViewportChange(() => focusPRFrame(matchedPR, sopUID));
        }
        if (!alreadyAnnotated) {
          await runProgrammaticViewportChange(() =>
            applyPRToViewport(matchedPR, viewportIndex, currentStack, { prUrl: matchedPRUrl })
          );
          setPrAppliedCount((c) => c + 1);
          setStudyPRAppliedCount((c) => c + 1);
        } else {
          await runProgrammaticViewportChange(() =>
            reapplyPRViewportState(matchedPR, viewportIndex)
          );
        }
      } else if (prModeActive) {
        // Non-PR frame while a PR is selected: restore the user's baseline zoom/pan/
        // window here so the PR's view does NOT bleed across the stack (Bug 2).
        await runProgrammaticViewportChange(() => restoreUserBaseline());
      }
      // If no PR is selected at all, leave the viewport untouched (normal scroll).
    };
    applyPRForCurrentFrame();
  }, [currentImage, viewportLoaded, prCheckCount]);

  // ── Keep the PR list panel in sync with the study structure ──────────────────
  // The PR list (prItems) is also built inside loadViewport, but that only runs
  // on (re)load. When a PR is saved and merged into studyData in place
  // (waitForSeriesReadyAndMerge), studyData gains a new PR series but the popup
  // stayed empty until a manual page reload. This effect rebuilds prItems whenever
  // the set of PR series changes, so a freshly-saved PR appears in the popup without
  // a reload. Existing selections are preserved by URL.
  // The stacks belonging to the study THIS viewport is showing. In the priors
  // (patient) viewer `studyData` is empty and each study's data lives in
  // priorStudyData ([0] = parent/current, [1..n] = priors); pick the entry whose
  // studyId matches this viewport's study so a viewport lists/loads ITS OWN
  // study's PR (and other) stacks — parent PRs on the parent viewport, prior PRs
  // on the prior viewport. Falls back to the parent entry, then to the
  // single-study `studyData` used by the normal (non-priors) viewer.
  const getViewportStudyStacks = () => {
    if (priorStudyData && priorStudyData.length > 0) {
      const vpStudy = viewportSeriesData?.[viewportIndex]?.study;
      const entry =
        (vpStudy != null &&
          priorStudyData.find((s) => String(s.studyId) === String(vpStudy))) ||
        priorStudyData[0];
      return entry?.stacks ?? [];
    }
    return studyData?.stacks ?? [];
  };

  // ── A series that grows while this viewport shows it ──────────────────────
  // An SC capture is merged into the study as an upsert of the shared "SC DICOM"
  // series (waitForScSeriesAndMerge): the series panel shows the new image, but
  // this viewport keeps the stack it loaded (viewportSeriesData + the cornerstone
  // viewport's imageIds + the thumbnail registry), so the capture was missing
  // here even when scrolling. When the study's copy of the shown series has more
  // images, swap them in at the current image, keeping zoom/pan and window.
  const growingSeriesRef = useRef(null);
  useEffect(() => {
    const entry = viewportSeriesData?.[viewportIndex];
    const shown = entry?.stack;
    if (!shown || !shown.seriesId || !Array.isArray(shown.imageIds)) return;
    const latest = getViewportStudyStacks().find((s) => s?.seriesId === shown.seriesId);
    if (!latest || latest === shown || !Array.isArray(latest.imageIds)) return;
    if (latest.imageIds.length <= shown.imageIds.length) return;
    // multi-frame / mixed-series viewports index frames, not the stack's images
    if (getEngine("viewport_" + viewportIndex) || getCurrentOuterIndex("viewport_" + viewportIndex) != null) return;
    if (growingSeriesRef.current === latest) return;
    growingSeriesRef.current = latest;

    (async () => {
      try {
        const viewport = await getViewport(viewportIndex);
        if (!viewport?.setStack) return;
        const camera = viewport.getCamera?.();
        const properties = viewport.getProperties?.();
        const index = Math.min(viewport.getCurrentImageIdIndex?.() ?? currentImage ?? 0,
          latest.imageIds.length - 1);
        await viewport.setStack(latest.imageIds, index);
        if (camera) viewport.setCamera(camera);
        if (properties) viewport.setProperties(properties);
        viewport.render();
        // Updated in place, not through setViewportSeriesData: a new
        // viewportSeriesData reloads the active viewport from scratch (the
        // thumbnail-click effect), which is the flash this avoids.
        entry.stack = latest;
        if (entry.thumbnailIndex !== undefined) replaceThumbnailStack(entry.thumbnailIndex, latest);
        setImageCount(latest.imageIds.length - 1); // the scrollbar's max index, as loadActiveViewport returns
      } catch (err) {
        console.warn("[Viewport] could not add the new images of the shown series:", err);
        growingSeriesRef.current = null;
      }
    })();
  }, [studyData?.stacks, priorStudyData]);

  /**
   * Add a ✏ PR marker for every image the given (parsed) PRs reference, matched
   * by SOP Instance UID. The backend's is_pr_present flag is set at ingestion by
   * looking the PR's Referenced SERIES UID up first — third-party PRs that carry
   * their own series UID there (Us2.ai) never match, so the image stays unflagged
   * and the PR widget is hidden. Deriving the marker from the PR files themselves
   * covers those (and already-ingested studies). Markers are image URLs, unique
   * per image, so adding one to both the parent and priors lists is harmless.
   */
  const markPRReferencedImages = (prUrls) => {
    const refSops = new Set();
    prUrls.forEach((url) =>
      (getCachedPRData(url)?.referencedSOPInstanceUIDs ?? []).forEach((u) => u && refSops.add(u.trim()))
    );
    if (!refSops.size) return;
    const urls = [];
    getViewportStudyStacks().forEach((stack) => {
      if (stack?.modality === "PR" || stack?.modality === "SR") return;
      (stack?.images ?? []).forEach((img, i) => {
        const sop = img?.sopInstanceUID?.trim();
        if (sop && refSops.has(sop) && stack.imageIds?.[i]) urls.push(stack.imageIds[i]);
      });
    });
    if (!urls.length) return;
    const merge = (prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const have = new Set(list.map((p) => p.imageUrl));
      const missing = urls.filter((u) => !have.has(u));
      return missing.length ? [...list, ...missing.map((imageUrl) => ({ imageUrl }))] : prev;
    };
    setPrImages?.(merge);
    if (priorStudyData?.length) setPriorStudyPRImages?.(merge);
  };

  /**
   * URL of EVERY Presentation State instance in this viewport's study. A PR
   * series may hold several PR objects — Us2.ai files all PRs for one clip
   * (one per frame) in a single series — so reading only the first instance
   * dropped the rest from the PR list.
   */
  const getStudyPRUrls = () => [
    ...new Set(
      getViewportStudyStacks()
        .filter((s) => s.modality === "PR")
        .flatMap((s) => s.thumbnailImageIds ?? [])
        .filter(Boolean)
    ),
  ];

  /** PR list item for a parsed PR. */
  const toPRItem = (url, prData, selected) => ({
    url,
    description: prData.contentDescription || prData.contentLabel || "",
    // (0070,0080) Content Label — Us2.ai puts the measurement names here
    // ("IVSd,LVIDd,LVPWd") while its description is only a UUID.
    label:       prData.contentLabel || "",
    creatorName: prData.contentCreatorName || "",
    date:        prData.presentationCreationDate || "",
    selected,
  });

  /**
   * PRs that reference the image on screen, for the PR list popup. On a
   * multi-frame clip each PR is scoped to one frame: carry that frame number
   * (the panel shows it and switches to single-select) and order by frame.
   */
  const getSlicePRItems = () => {
    if (!currentSopUID) return [];
    return prItems
      .flatMap((item) => {
        const prData = getCachedPRData(item.url);
        if (!prData?.referencedSOPInstanceUIDs?.some((u) => u?.trim() === currentSopUID)) return [];
        const frameNumber = getPRFrameTargets(prData)
          .find((t) => t.sop === currentSopUID)?.frameNumber ?? null;
        return [{ ...item, frameNumber }];
      })
      .sort((a, b) => (a.frameNumber ?? 0) - (b.frameNumber ?? 0));
  };

  const prStackUrlKey = getStudyPRUrls().join("|");
  useEffect(() => {
    const prUrls = getStudyPRUrls();
    if (!prUrls.length) { setPrItemsLoading(false); return; }
    let cancelled = false;
    // Mark loading BEFORE the first await so the PR popup renders "Loading…"
    // rather than "No PR files" while the DICOM parse is still in flight.
    setPrItemsLoading(true);
    (async () => {
      // Parse all PR files for this study CONCURRENTLY (was sequential await in a
      // for-loop → N back-to-back round-trips). Each parsePRFile is cached by URL,
      // and the URLs here are distinct, so Promise.all is safe and collapses the
      // total wait to the single slowest fetch instead of their sum.
      const results = await Promise.all(
        prUrls.map(async (prUrl) => {
          try {
            const prData = await parsePRFile(prUrl); // cached after first parse
            return toPRItem(prUrl, prData, false);
          } catch (err) {
            console.warn("Failed to parse PR (list sync):", prUrl, err);
            return null;
          }
        })
      );
      if (cancelled) return;
      markPRReferencedImages(results.filter(Boolean).map((r) => r.url));
      const items = results.filter(Boolean);
      // Merge: keep any existing selection state, keyed by URL.
      const prevByUrl = new Map(prItemsRef.current.map((i) => [i.url, i]));
      setPrItems(items.map((it) => {
        const prev = prevByUrl.get(it.url);
        return prev ? { ...it, selected: prev.selected } : it;
      }));
      setPrItemsLoading(false);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prStackUrlKey]);

  // ── PR list panel toggle handlers ────────────────────────────────────────────

  /**
   * Helper: after removing a PR, reset the viewport to its pre-PR state then
   * re-apply viewport state (VOI LUT + camera) from any still-selected PRs on
   * this slice.  Annotations for the still-selected PRs are already in the
   * manager — only the viewport state needs refreshing.
   */
  const _resetAndRestoreViewportState = async (nextItems) => {
    const vp = await getViewport(viewportIndex);
    if (!vp) return;
    // Reset viewport to original (no-PR) state.
    vp.resetCamera({ resetPan: true, resetZoom: true, resetToCenter: true });
    vp.resetProperties();
    // Re-apply viewport state from PRs that are still selected on this slice.
    if (currentSopUID) {
      const stillSelected = nextItems.filter((i) => i.selected);
      for (const rem of stillSelected) {
        const pd = getCachedPRData(rem.url);
        if (!pd) continue;
        const refersHere = pd.referencedSOPInstanceUIDs?.some((u) => u.trim() === currentSopUID);
        if (refersHere) await reapplyPRViewportState(pd, viewportIndex);
      }
    }
    vp.render();
  };

  // ── Spine-label PRs → native overlay ─────────────────────────────────────────
  // Spine labels are NOT Cornerstone annotations; they live in ViewportContext
  // (spineLabels) and render as the styled SVG overlay. When a PR carrying spine
  // labels is selected, restore them into that overlay (tagged with the PR url so
  // they can be removed again on deselect). Idempotent per url.
  const applySpinePRLabels = (prData, url) => {
    if (!prData?.spineLabels?.length) return;
    const currentStack = viewportSeriesData[viewportIndex]?.stack;
    const overlay = buildSpineOverlayLabels(prData, currentStack, viewportIndex, url);
    if (!overlay.length) return;
    setSpineLabels((prev) => {
      const kept = (prev || []).filter((l) => l.prUrl !== url);
      return [...kept, ...overlay];
    });
  };
  const removeSpinePRLabels = (url) => {
    setSpineLabels((prev) => (prev || []).filter((l) => l.prUrl !== url));
  };

  const handlePRToggle = async (url) => {
    const item = prItems.find((i) => i.url === url);
    if (!item) return;

    if (item.selected) {
      // Deselect: remove this PR's annotations, reset viewport, restore remaining.
      removePRAnnotationsByUrl(url, null);
      removeSpinePRLabels(url);
      const nextItems = prItems.map((i) => i.url === url ? { ...i, selected: false } : i);
      setPrItems(nextItems);
      await runProgrammaticViewportChange(() => _resetAndRestoreViewportState(nextItems));
    } else {
      const prData = getCachedPRData(url);

      // Multi-frame clip: each PR belongs to ONE frame, so the clip's PRs are
      // single-select (Advance Viewer parity) — selecting one swaps out any other
      // selected PR on this clip before the new one is applied.
      let baseItems = prItems;
      const frameScoped = !!currentSopUID &&
        getPRFrameTargets(prData).some((t) => t.sop === currentSopUID);
      if (frameScoped) {
        const others = prItems.filter((i) =>
          i.selected && i.url !== url &&
          getCachedPRData(i.url)?.referencedSOPInstanceUIDs?.some((u) => u?.trim() === currentSopUID));
        if (others.length) {
          others.forEach((o) => { removePRAnnotationsByUrl(o.url, null); removeSpinePRLabels(o.url); });
          const otherUrls = new Set(others.map((o) => o.url));
          baseItems = prItems.map((i) => otherUrls.has(i.url) ? { ...i, selected: false } : i);
          setPrItems(baseItems);
          // Sync the ref NOW: the frame jump below re-runs the reactive PR effect,
          // which must not see (and re-apply) the PR just swapped out.
          prItemsRef.current = baseItems;
          // Drop the previous PR's windowing / zoom (if it carried any) before the
          // new PR's view is applied.
          const hadViewState = others.some((o) => {
            const d = getCachedPRData(o.url);
            return d?.voiLUT || d?.displayedArea || d?.rotation || d?.horizontalFlip;
          });
          if (hadViewState) {
            await runProgrammaticViewportChange(() => _resetAndRestoreViewportState(baseItems));
          }
        }
      }

      // Selecting a PR: remember the user's current view as the baseline for non-PR
      // frames (Bug 2), then apply the PR fully (annotations + viewport state). The
      // PR view is shown on its own frame; other frames restore this baseline.
      await captureUserBaseline();
      if (prData) {
        const currentStack = viewportSeriesData[viewportIndex]?.stack;
        // Multi-frame PR: land on the frame it was drawn on, paused.
        await runProgrammaticViewportChange(() => focusPRFrame(prData, currentSopUID));
        await runProgrammaticViewportChange(() =>
          applyPRToViewport(prData, viewportIndex, currentStack, { prUrl: url })
        );
        applySpinePRLabels(prData, url);
      }
      setPrItems((prev) => prev.map((i) => i.url === url ? { ...i, selected: true } : i));
    }
  };

  // sliceItems = the already-filtered list of PRs for the current slice.
  const handlePRToggleAll = async (selectAll, sliceItems) => {
    const itemsToProcess = sliceItems ?? prItems;
    const urlsToProcess  = new Set(itemsToProcess.map((i) => i.url));

    if (selectAll) {
      // Remember the user's current view as the baseline for non-PR frames (Bug 2)
      // before applying, then re-apply all deselected PRs in this slice.
      await captureUserBaseline();
      const currentStack = viewportSeriesData[viewportIndex]?.stack;
      let focused = false;
      for (const item of itemsToProcess) {
        if (!item.selected) {
          const prData = getCachedPRData(item.url);
          if (prData) {
            // Land on the first multi-frame PR's frame (later PRs don't move it).
            if (!focused) {
              focused = await runProgrammaticViewportChange(() => focusPRFrame(prData, currentSopUID));
            }
            await runProgrammaticViewportChange(() =>
              applyPRToViewport(prData, viewportIndex, currentStack, { prUrl: item.url })
            );
            applySpinePRLabels(prData, item.url);
          }
        }
      }
      setPrItems((prev) => prev.map((i) => urlsToProcess.has(i.url) ? { ...i, selected: true } : i));
    } else {
      // Deselect all: remove annotations, reset viewport (nothing to restore after).
      for (const item of itemsToProcess) {
        if (item.selected) { removePRAnnotationsByUrl(item.url, null); removeSpinePRLabels(item.url); }
      }
      const nextItems = prItems.map((i) => urlsToProcess.has(i.url) ? { ...i, selected: false } : i);
      setPrItems(nextItems);
      // All cleared — reset to original viewport state with no re-apply.
      await runProgrammaticViewportChange(() => _resetAndRestoreViewportState(nextItems));
    }
  };

  // useEffect(() => {
  //   if (viewportLoading.viewport1Loading) {
  //     updateBBPosition(studyBoundingBox);
  //   }
  // }, [activeViewportIndex, currentImage, viewportLoading]);

  const handleShowOriginalToggle = async () => {
    const currentStackModality = viewportSeriesData[activeViewportIndex]?.stack?.modality;
    if (activeViewportIndex === viewportIndex && currentStackModality !== "PR") {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await changeStack(
        activeViewportIndex,
        thumbnailId,
        viewportSeriesData[activeViewportIndex].stack,
        viewportSeriesData[activeViewportIndex].originalStack,
        originalImageActiveState[viewportIndex],
        currentImage,
        setLoaderRunning,
        ref
      );
      setTimeout(() => {
        ref.current.complete();
      }, 500);
      if (originalImageActiveState[viewportIndex]) {
        logViewOriginalImage(studyParentId);
      }
    }
  };

  useEffect(() => {
    if (viewportRendered) {
      handleShowOriginalToggle();
    }
  }, [originalImageActiveState]);

  const enableViewportElement = async () => {
    setViewportLoaderRunning(false);
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    addViewportElement(element);
    setViewportElement(element);
    activationRef.current = activateViewport(element, viewportIndex);
    setViewportModality(activeModality);
    setActiveViewportModality(activeModality);
    setIsActivated(true);
    // if (viewportIndex !== 0) {
    //   setViewportLoaderRunning(false);
    // }
  };

  useEffect(() => {
    enableViewportElement();
  }, []);

  const loadLateralSeriesInViewport = async () => {
    setViewportLoaderRunning(true);
    const toolGroup = await getToolGroupManager(
      getEnv("REACT_APP_TOOL_GROUP_ID")
    );
    toolGroup.addTool(cornerstonetools.ReferenceLinesTool.toolName);
    setIsReferenceLineActivated(true);
    setThumbnailId(lateralThumbnailIndex);
    setViewportLoaded(true);
    await loadViewport(lateralThumbnailIndex, viewportIndex);
    setIsReferenceLinesEnabled(true);
    await updateVoiForTheVeryFirstTimeForLateralSeries();
    setAllLoadingComplete(true);
  };

  const updateVoiForTheVeryFirstTimeForLateralSeries = async () => {
    const viewport = await getViewport(1);
    setVOI({
      windowCenter: Math.trunc(viewport.csImage.windowCenter),
      windowWidth: Math.trunc(viewport.csImage.windowWidth),
    });
  };

  useEffect(() => {
    if (
      lateralThumbnailIndex !== null &&
      lateralThumbnailIndex !== undefined &&
      viewportIndex === 1
    ) {
      loadLateralSeriesInViewport();
    }
  }, [lateralThumbnailIndex]);

  const getLateralSeriesIndex = async () => {
    // The priors viewer keeps the current study at priorStudyData[0] and hangs
    // every prior's series in the same thumbnail list. Only the current study's
    // series may fill the lateral viewport, so bound the search by its series
    // count — KO/PR excluded, since ThumbnailList skips them when numbering.
    const currentStudy =
      priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData;
    const seriesCount = (currentStudy?.stacks || []).filter(
      (stack) => stack.modality !== "KO" && stack.modality !== "PR"
    ).length;

    let index = await checkForLateralSeries(seriesCount);
    if (index !== -1) {
      setLateralThumbnailIndex(index);
    }
  };

  // The lateral series always loads into view 2 (see the viewportIndex === 1
  // guard above), which a hanging protocol may have claimed — for one of the
  // current study's series, or since prior hanging, for a prior study's. So this
  // waits until the protocol pipeline says nothing will hang.
  //
  // hpDataList alone was not enough: it is the v1 protocol list, and a user with
  // only v2 protocols has none, so the guard passed and the lateral series
  // overwrote the hang a moment after it landed. hpWillHang is the tri-state the
  // startup series load already waits on — null while deciding, so anything but
  // an explicit false means hold off. Keyed on it as well as the thumbnails,
  // since either can settle last.
  useEffect(() => {
    if (!thumbnailLoadingComplete || isMobile) return;
    if (hpWillHang !== false) return;
    if (hpDataList && Object.keys(hpDataList).length !== 0) return;
    getLateralSeriesIndex();
  }, [thumbnailLoadingComplete, hpWillHang]);

  useEffect(() => {
    if (viewportIndex === activeViewportIndex) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [isReferenceLinesEnabled]);

  useEffect(() => {
    // Only let one viewport instance handle the active-viewport change to
    // avoid multiple simultaneous toggleReferenceLines calls that race.
    if (isReferenceLinesEnabled && viewportIndex === activeViewportIndex) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }
  }, [activeViewportIndex]);

  useEffect(() => {
    // Reference lines depend on the active (source) viewport sharing a
    // meaningful frame of reference with the others — see cornerstone's
    // ReferenceLinesTool enforceSameFrameOfReference check. CR/DX/US/SR/SC
    // images (e.g. a prior X-ray dropped into the active viewport) don't
    // carry one, so the lines it would project are meaningless. When the
    // active viewport's own content switches to one of these, turn the
    // cornerstone tool off — without touching isReferenceLinesEnabled (the
    // user's own toggle) — so loading a compatible series back into the
    // active viewport re-activates reference lines automatically.
    if (viewportIndex !== activeViewportIndex || !isReferenceLinesEnabled) {
      return;
    }
    if (REFLINES_SYNC_EXCLUDED_MODALITIES.includes(activeViewportModality)) {
      toggleReferenceLines(false, activeViewportIndex);
    } else {
      toggleReferenceLines(true, activeViewportIndex);
    }
  }, [activeViewportModality]);

  const updateInitialVOI = async () => {
    const viewport = await getViewport(viewportIndex);
    setVOI({
      windowCenter: viewport?.csImage?.windowCenter,
      windowWidth: viewport?.csImage?.windowWidth,
    });
  };

  const loadViewport = async (thumbnailIndex, viewportIndex, seriesStack = null) => {
    // A load can arrive in the same commit as the mount that enables this
    // viewport - a hanging protocol re-mounts the grid and loads straight into
    // it. If that mount is also what creates the rendering engine (mobile has
    // nothing mounted before the hang), getViewport can overtake the pending
    // enableElement, find no viewport, and loadActiveViewport silently bails
    // with the slot left blank. So the enable has to land first. (A failed
    // enable still falls through to loadActiveViewport's own no-viewport exit.)
    await activationRef.current?.catch(() => {});
    // Seed the thumbnail registry from the assigned series so
    // loadActiveViewport's getThumbnailViewport(thumbnailIndex) lookup never
    // misses for a series whose thumbnail hasn't lazily rendered yet (priors /
    // multiple studies). Idempotent — preserves an entry displayThumbnail
    // already created (unless that series has since grown — see
    // registerThumbnailStack). A drop passes the dropped stack: this render's
    // viewportSeriesData still holds the previous series.
    registerThumbnailStack(
      thumbnailIndex,
      seriesStack || viewportSeriesData[viewportIndex]?.stack
    );
    setViewportLoaderRunning(true);
    setViewportLoading(() => {
      const newVal = { ...viewportLoading };
      if (viewportIndex == 0) {
        newVal.viewport1Loading = false;
      } else if (viewportIndex == 1) {
        newVal.viewport2Loading = false;
      } else if (viewportIndex == 2) {
        newVal.viewport3Loading = false;
      } else {
        newVal.viewport4Loading = false;
      }

      return newVal;
    });
    let maxImageCount;
    try {
      maxImageCount = await loadActiveViewport(
        thumbnailIndex,
        viewportIndex,
        setScale,
        setInitialVOIRange,
        setInitialVOI,
        isScrollingUp,
        setCurrentImage,
        currentImage,
        loadAIOutlineAndHeatmap,
        hpLoading
          ? viewportHpImage?.get(viewportIndex)
          // Series-panel instance tile click: open the series at that instance.
          : (viewportSeriesData[viewportIndex]?.initialImageIndex ?? 0),
      );
    } catch (err) {
      // loadActiveViewport has no internal error handling and loadViewport is
      // not wrapped by its callers, so a rejection here used to skip every line
      // below — including setViewportLoaderRunning(false) — leaving the
      // full-viewport spinner stuck forever. This surfaced in the priors viewer,
      // which mounts several study viewports at once (current + priors): if any
      // one of them fails to load its series, that viewport spins the spinner
      // indefinitely. Clear the overlay and bail out of this viewport's load.
      console.error("[Viewport] loadActiveViewport failed — clearing loader:", err);
      setViewportLoaderRunning(false);
      // With no image there is no presentation for a hanging protocol to write,
      // and nothing here will ever report in on its own - so report now rather
      // than make the whole hang (and every other viewport's curtain) wait out
      // the timeout on a viewport that has already failed.
      markHpViewportApplied(viewportIndex, hpApplyToken);
      return;
    }
    if(isScrollingUp){
      setIsScrollingUp(false);
    }
    if (viewportIndex === 0 || hpLoading) setImageLoadedOnViewport(true);
    setAllowAddingTextAnnotation(true);
    setViewportRendered(true);
    setTimeout(() => {
      setViewportLoading(() => {
        const newVal = { ...viewportLoading };
        if (viewportIndex == 0) {
          newVal.viewport1Loading = true;
        } else if (viewportIndex == 1) {
          newVal.viewport2Loading = true;
        } else if (viewportIndex == 2) {
          newVal.viewport3Loading = true;
        } else {
          newVal.viewport4Loading = true;
        }

        return newVal;
      });
    }, 1000);
    setImageCount(maxImageCount);
    if (
      !LATERAL_VIEW_MODALITY_LIST.includes(studyModality) ||
      isMobile ||
      sharedViewer
    ) {
      setLoaderRunning(false);

    }
    updateInitialVOI();
    setAllLoadingComplete(true);

    // Clear the full-viewport loading overlay as soon as the image is on
    // screen — BEFORE the best-effort PR/KO parsing below. Those loops await
    // parsePRFile/parseKOFile per stack; on the priors path (wadouri, multiple
    // studies) a slow or non-settling parse would otherwise keep the spinner
    // up forever even though the viewport already rendered. The final
    // setViewportLoaderRunning(false) at the end of this function is kept as a
    // harmless idempotent backstop.
    setViewportLoaderRunning(false);

    // A completed load is what an alignment lock has to re-assert against: the
    // new series came up fitted and centred like any other. Bumped here, once
    // the image is on screen, rather than keyed off the series id - that changes
    // when the drop is accepted, which is before there is anything to align.
    setViewportLoadEpoch((n) => n + 1);

    // Parse all Presentation State series so the PR list panel can offer them,
    // but do NOT auto-apply or auto-select — auto-open is OFF (bug 8). Source the
    // PR stacks from THIS viewport's study (parent or prior) so PRs display in the
    // patient viewer, where studyData is empty and data lives in priorStudyData.
    const prUrls = getStudyPRUrls();
    const newPrItems = [];

    // Seed the user "baseline" view (Bug 2) from the natural view at load, so a PR
    // selected later restores to this baseline on non-PR frames until the user makes
    // their own adjustment. Best-effort — if the viewport isn't ready yet, the
    // baseline is (re)captured on the next manual change or when a PR is selected.
    if (prUrls.length > 0) {
      await captureUserBaseline();
    }

    // Preserve any PR the user had selected across a re-load (e.g. a layout change),
    // so changing the grid does NOT drop an applied PR (Bug 1). The reactive PR effect
    // re-applies the still-selected PRs to the current frame after this rebuild.
    const prevSelectedByUrl = new Map(
      prItemsRef.current.map((i) => [i.url, i.selected === true])
    );
    for (const prUrl of prUrls) {
      try {
        // Parse + cache (populates the list panel). Application happens via the
        // reactive PR effect / handlePRToggle — not auto-opened on study open (bug 8).
        const prData = await parsePRFile(prUrl);
        newPrItems.push(toPRItem(prUrl, prData, prevSelectedByUrl.get(prUrl) === true));
      } catch (err) {
        console.warn("Failed to parse PR:", err);
      }
    }
    if (newPrItems.length > 0) {
      setPrItems(newPrItems);
      // Nudge the reactive PR effect so preserved selections re-apply after a reload
      // (prItemsRef is synced before that effect re-runs).
      if (newPrItems.some((i) => i.selected)) setPrCheckCount((c) => c + 1);
    }

    // ── Auto-parse all Key Object stacks ──────────────────────────────────────
    // Each KO DICOM is a separate file; parsing them lets us show multiple KOs
    // per slice in the ViewportNavWidget star popup (the backend's per-image
    // keyImageTitle only stores one title even when several KOs reference the
    // same image).
    //
    // Look at every stack and accept anything that LOOKS like a KO — some
    // backends label the modality "KO", others "KEY OBJECT" or set only the
    // SOP Class UID.  Try every imageId on the stack as a URL, not just
    // thumbnailImageIds[0], since KO stacks often lack a thumbnail entry.
    const KO_SOP_CLASS = "1.2.840.10008.5.1.4.1.1.88.59";
    const allStacks = studyData.stacks ?? [];
    const koStacks = allStacks.filter((s) => {
      const mod = (s.modality || "").toUpperCase();
      return mod === "KO" || mod === "KEY OBJECT"
          || s.sopClassUid === KO_SOP_CLASS
          || s.sopClassUId === KO_SOP_CLASS;
    });

    for (const koStack of koStacks) {
      const candidateUrls = [
        ...(koStack.thumbnailImageIds ?? []),
        ...(koStack.imageIds ?? []),
      ].filter(Boolean);
      let parsedOk = false;
      for (const koUrl of candidateUrls) {
        try {
          const koData = await parseKOFile(koUrl);
          parsedOk = true;
          break;
        } catch (err) {
          console.warn("[KO] parse failed for", koUrl, err);
        }
      }
      if (!parsedOk) console.warn("[KO] no usable URL on stack", koStack);
    }
    setViewportLoaderRunning(false);
  };

  // Object URL currently held by this viewport's PDF pane. Kept in a ref so the
  // unmount cleanup can revoke it without re-subscribing on every state change.
  const pdfObjectUrlRef = useRef(null);
  // A slow fetch for a series the user has already navigated away from must not
  // overwrite the document of the series now showing; every load takes a token
  // and only the newest one is allowed to publish its result.
  const pdfRequestTokenRef = useRef(0);

  const setPdfDocumentSafely = (next) => {
    if (pdfObjectUrlRef.current && pdfObjectUrlRef.current !== next?.objectUrl) {
      releaseEncapsulatedPDF(pdfObjectUrlRef.current);
    }
    pdfObjectUrlRef.current = next?.objectUrl ?? null;
    setPdfDocument(next);
  };

  /**
   * Load an Encapsulated PDF (modality DOC) series into this viewport.
   *
   * Nothing here touches cornerstone: the instance carries a PDF in
   * Encapsulated Document (0042,0011) rather than pixel data, so the series is
   * fetched as a raw DICOM object, parsed, and rendered as a document - the same
   * shape of handling SR gets, and the reason buildSeriesStack routes DOC to the
   * storage-key endpoint instead of the image loaders.
   */
  const showEncapsulatedPDF = async (stack) => {
    const token = ++pdfRequestTokenRef.current;
    setPdfError(null);
    setPdfLoading(true);
    setPdfDocumentSafely(null);
    try {
      const path = stack?.thumbnailImageIds?.[0];
      if (!path) throw new Error("Series carries no document instance.");
      const result = await loadEncapsulatedPDF(path);
      if (token !== pdfRequestTokenRef.current) {
        // Superseded while in flight - release what we just built instead of
        // publishing it over the series the user actually selected.
        releaseEncapsulatedPDF(result?.objectUrl);
        return;
      }
      // A 403 redirects to login and resolves null; there is nothing to show.
      if (result) setPdfDocumentSafely(result);
    } catch (error) {
      if (token !== pdfRequestTokenRef.current) return;
      console.error("Failed to load encapsulated PDF", error);
      setPdfError(error?.message ?? String(error));
    } finally {
      if (token === pdfRequestTokenRef.current) setPdfLoading(false);
    }
  };

  // Revoke the outstanding object URL on unmount - without this every viewport
  // that ever showed a PDF pins its blob for the lifetime of the page.
  useEffect(() => {
    return () => {
      releaseEncapsulatedPDF(pdfObjectUrlRef.current);
      pdfObjectUrlRef.current = null;
    };
  }, []);

  /**
   * Unified function for loading a series into a viewport.
   * Used by both drag-drop and thumbnail click flows.
   * @param {number} thumbnailIndex - Index of the thumbnail/series to load
   * @param {number} targetViewportIndex - Target viewport index
   * @param {object} [seriesStack] - Stack data (pass explicitly for drag-drop since viewportSeriesData may not be updated yet)
   */
  const loadSeriesIntoViewport = async (
    thumbnailIndex,
    targetViewportIndex,
    seriesStack = null,
    overlayStacks = null
  ) => {
    const stack = seriesStack || viewportSeriesData[targetViewportIndex]?.stack;

    // Clear any stale scroll-sync loader from a previous series before loading a new one.
    clearScrollImageLoader();
    setViewportLoaderRunning(true);
    setViewportProgressComplete(false);
    setViewportProgress(20);
    setViewportModality(activeModality);
    setActiveViewportModality(activeModality);

    // Handle Encapsulated PDF modality.
    //
    // Read the modality off the stack rather than from activeModality: on the
    // drag-drop path setActive() has not re-rendered yet, so activeModality
    // still holds the PREVIOUS series own value. handleDrop passes the dropped
    // series modality through overlayStacks; the stack itself carries it in
    // both paths (buildSeriesStack sets it and preserves DOC own value).
    const loadedModality =
      overlayStacks?.modality ?? stack?.modality ?? activeModality;
    if (loadedModality === "DOC") {
      // The PDF pane is keyed off viewportModality, which was just set from the
      // possibly-stale activeModality - pin it to the series actually loading.
      setViewportModality("DOC");
      setActiveViewportModality("DOC");
      await showEncapsulatedPDF(stack);
      setViewportLoaderRunning(false);
      // The document IS the loaded content, so report the viewport complete the
      // way the image path does below. TopBar puts `disable-toolbar` on its left
      // toolbar until this flips, so leaving it false greys out the Series
      // button (and the rest of that group) for a document-only study.
      if (targetViewportIndex === 0) {
        setImageLoadedOnViewport(true);
        setViewportLoadingComplete(true);
      }
      return;
    }

    // Handle SR modality
    if (activeModality === "SR") {
      generateSRReport(stack.thumbnailImageIds[0], setSRReport);
      setTimeout(() => {
        setViewportLoaderRunning(false);
        setIsSrSelected(true);
        // The generated report IS the loaded content, so report the viewport
        // complete the way the image path does below. TopBar puts
        // `disable-toolbar` on its left toolbar until this flips, so leaving it
        // false greys out the Series button for a report-only study.
        if (targetViewportIndex === 0) {
          setImageLoadedOnViewport(true);
          setViewportLoadingComplete(true);
        }
      }, 1000);
      return;
    }

    setViewportLoaded(true);
    setThumbnailId(thumbnailIndex);
    await loadViewport(thumbnailIndex, targetViewportIndex, seriesStack);
    setViewportProgress(100);
    if (isHeatMapEnabled || isOutlineEnabled) {
      loadAIOutlineAndHeatmap(overlayStacks);
    }
    setViewportLoaderRunning(false);
    if (targetViewportIndex === 0) setViewportLoadingComplete(true);

    resetRotation(targetViewportIndex);
    resetStackPosition(targetViewportIndex);
  };

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  const handleLoadSecondTime = async () => {
    if (viewportSeriesData[viewportIndex].stack != "" && !hpLoading) {
      await loadSeriesIntoViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);
      rerenderViewport();
      // Re-assert HP WW/WL after the second load resets it to the natural window.
      const hpLayout = viewportHpLayout.get(viewportIndex);
      if (hpLayout && hpLayout.windowWidth && hpLayout.windowLevel) {
        setVOILUTRange(viewportIndex, hpLayout.windowWidth, hpLayout.windowLevel);
      }
    }
  };

  useEffect(() => {
    const handleThumbnailClick = async () => {
      if (
        viewportIndex === activeViewportIndex &&
        viewportSeriesData[viewportIndex].stack != "" && !hpLoading &&
        activeThumbnailIndex !== undefined
      ) {
        await loadSeriesIntoViewport(activeThumbnailIndex, activeViewportIndex);
      }
    };
    if (!dragEvent) {
      handleThumbnailClick();
    }
  }, [viewportSeriesData]);

  useEffect(() =>{
    if(hpLoading){
      setLoaderRunning(true);
      ref.current.continuousStart();
    }
  },[hpLoading])

  // ── Flicker curtain ───────────────────────────────────────────────────────
  // A protocol can only be written onto an image cornerstone has already
  // rendered: window level, alignment, rotation, flip and zoom all go through
  // the loaded viewport's camera. So the untransformed image is necessarily on
  // the canvas first, and revealing it there means watching the presentation
  // assemble itself - the image appears, re-windows, rotates, then zooms.
  //
  // Instead the pixels stay behind an opaque cover for the whole hang and the
  // viewport just shows its ordinary spinner a little longer. hpLoading clears
  // in ViewportState only once every viewport has written its presentation, so
  // all the curtains lift together on a finished layout.
  //
  // Only viewports the hang actually fills are covered; an empty slot in the
  // grid keeps showing its "drag a series here" message.
  const hpCurtainDown = hpLoading && !!viewportSeriesData?.[viewportIndex]?.stack;

  useEffect(() => {
    const handleHPLoading = async () => {
      if (
        hpLoading &&
        viewportSeriesData[viewportIndex].stack != ""
      ) {
        setViewportLoaderRunning(true);

        const firstValidIndex = viewportSeriesData.findIndex(
          (v) => v.stack !== ""
        );
        
        if(firstValidIndex === viewportIndex){
          setActiveModality(viewportSeriesData[viewportIndex].modality);
          changeActiveThumbnailIndex(viewportSeriesData[viewportIndex].thumbnailIndex);
          setActiveViewportModality(viewportModality);
          changeActiveViewportIndex(viewportIndex);
          let studyIdString = viewportSeriesData[viewportIndex].study;
          let studyIdInteger = parseInt(studyIdString, 10);
          setActiveStudyId(studyIdInteger);
        }
        setViewportModality(viewportSeriesData[viewportIndex].modality);
        if (viewportSeriesData[viewportIndex].modality === "DOC") {
          await showEncapsulatedPDF(viewportSeriesData[viewportIndex].stack);
          setViewportLoaderRunning(false);
          // Same as the thumbnail path: the document is the loaded content, so
          // release TopBar's `disable-toolbar` gate on the Series button.
          setViewportLoadingComplete(true);
          if (viewportIndex === 0) setImageLoadedOnViewport(true);
          // Like SR, a document viewport has no camera or VOI for the protocol
          // to write into, so report in immediately - ViewportState finishes the
          // hang only once every viewport has reported.
          markHpViewportApplied(viewportIndex, hpApplyToken);
          return;
        }
        if (viewportSeriesData[viewportIndex].modality === "SR") {
          generateSRReport(
            viewportSeriesData[viewportIndex].stack.thumbnailImageIds[0],
            setSRReport
          );
          setTimeout(() => {
            setViewportLoaderRunning(false);
            // Same as the thumbnail path: the report is the loaded content, so
            // release TopBar's `disable-toolbar` gate on the Series button.
            setViewportLoadingComplete(true);
            if (viewportIndex === 0) setImageLoadedOnViewport(true);
          }, 1000);
          // An SR viewport shows generated text, not an image, so the protocol
          // has no presentation to write into it. Report in so the hang isn't
          // left waiting on this viewport - ViewportState finishes the hang
          // (resize, tool, loader) once every viewport has reported, so that
          // no longer happens from here.
          markHpViewportApplied(viewportIndex, hpApplyToken);
          return;
        }
        setViewportLoaded(true);
        await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);

        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        setViewportLoaded(true);
        setHPSeriesDataLoaded(true);
        setViewportLoadingComplete(true);

        // Re-assert HP WW/WL after loadViewport resets it to the natural window.
        const hpLayout = viewportHpLayout.get(viewportIndex);
        if (hpLayout && hpLayout.windowWidth && hpLayout.windowLevel) {
          setVOILUTRange(viewportIndex, hpLayout.windowWidth, hpLayout.windowLevel);
        }
      }
    };
    if (!dragEvent) {
        handleHPLoading();
    }
  }, [viewportSeriesData, hpLoading]);

  // Auto-load series mode: load series into this viewport when isAutoLoadLayout is set
  useEffect(() => {
    const handleAutoLoad = async () => {
      if (
        isAutoLoadLayout &&
        viewportSeriesData[viewportIndex]?.stack &&
        viewportSeriesData[viewportIndex].stack !== ""
      ) {
        setViewportLoaderRunning(true);

        const firstValidIndex = viewportSeriesData.findIndex(v => v.stack !== "");
        if (firstValidIndex === viewportIndex) {
          setActiveModality(viewportSeriesData[viewportIndex].modality);
          changeActiveThumbnailIndex(viewportSeriesData[viewportIndex].thumbnailIndex);
          setActiveViewportModality(viewportSeriesData[viewportIndex].modality);
          changeActiveViewportIndex(viewportIndex);
          const studyIdInteger = parseInt(viewportSeriesData[viewportIndex].study, 10);
          setActiveStudyId(studyIdInteger);
        }
        setViewportModality(viewportSeriesData[viewportIndex].modality);

        await loadViewport(viewportSeriesData[viewportIndex].thumbnailIndex, viewportIndex);

        if (isHeatMapEnabled || isOutlineEnabled) loadAIOutlineAndHeatmap();
        setViewportLoaded(true);
        setViewportLoadingComplete(true);
        setViewportLoaderRunning(false);

        const lastValidViewportIndex = viewportSeriesData.findLastIndex(
          v => v.stack !== ""
        );
        if (lastValidViewportIndex === viewportIndex) {
          setTimeout(() => {
            resizeViewport();
            setIsAutoLoadLayout(false);
            setLoaderRunning(false);
            ref.current.complete();
          }, 600);
        }
      }
    };
    handleAutoLoad();
  }, [isAutoLoadLayout]);

  /**
   * Write this viewport's share of the protocol: flip, window level, alignment,
   * rotation, then zoom.
   *
   * Sequenced with awaits rather than fired off in parallel timers because
   * every one of these goes through the same camera - alignment and rotation
   * both refit it, so a scale set before them is recomputed away. (The Advance
   * Viewer gets the same result from the other order because its alignment only
   * pans.) The short wait before the rotation is cornerstone's: setOptions
   * renders on the next frame, and touching the camera before that frame reads
   * back the old fit.
   *
   * None of this is visible while it happens - the viewport's curtain stays
   * down until the hang reports finished. The resize and zoom re-assert that
   * used to end this function now live in ViewportState so they run once for
   * the whole hang, after every viewport has written its own presentation,
   * rather than once per viewport on a timer that could beat a slower one.
   */
  const applyViewportLayout = async (viewportIndex, token) => {
    const layout = viewportHpLayout.get(viewportIndex);
    if (!layout) {
      markHpViewportApplied(viewportIndex, token);
      return;
    }

    try {
      if (layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE) {
        await FlipHorizontally(viewportIndex);
      }

      if (layout.flipVertically === HP_VIEWPORT_FLIP.ENABLE) {
        await FlipVertically(viewportIndex);
      }

      if (layout.windowWidth && layout.windowLevel) {
        await setVOILUTRange(viewportIndex, layout.windowWidth, layout.windowLevel);
      }

      await setStackPosition(
        viewportIndex,
        layout.alignment,
        layout.rotation,
        layout.flipHorizontally === HP_VIEWPORT_FLIP.ENABLE
      );

      await new Promise((resolve) => setTimeout(resolve, HP_CAMERA_SETTLE_MS));
      await setRotation(viewportIndex, layout.rotation);

      if (layout.zoomFactor) {
        await applyViewportScale(viewportIndex, layout.zoomFactor, layout.alignment);
      }
    } catch (e) {
      // A viewport that cannot take its transforms must not hold the hang open
      // - the others are waiting behind their curtains for it to report.
      console.warn(
        "Hanging protocol: could not apply the viewport presentation",
        viewportIndex,
        e
      );
    }

    markHpViewportApplied(viewportIndex, token);
  };


  // const setHpCurrentImage = () => {
  //   startPrefetching();
  //   setViewportLoaderRunning(false);
  //     const imageIndex = viewportHpImage.get(viewportIndex); 
  //     if(imageIndex){
  //       setCurrentImage(imageIndex);
  //       setImageIndex(viewportIndex, imageIndex);
  //     }
  //     const lastValidViewportIndex = viewportSeriesData.findLastIndex(
  //       (viewport) => viewport.stack !== ""
  //     );
  //     setTimeout(() => {
  //       if(lastValidViewportIndex == viewportIndex){
  //         resizeViewport();
  //         setHpLoading(false);
  //         ref.current.complete();
  //       }
  //     }, 500);
  // };

  // A new hang: forget the last one's load state so this viewport waits for its
  // new series instead of transforming whatever is still on the canvas.
  useEffect(() => {
    if (!hpApplyToken) return;
    setHPSeriesDataLoaded(false);
  }, [hpApplyToken]);

  // Once per hang, and only after the camera reset in the "image as a line"
  // hack has run - it resets pan/zoom/centre, which would wipe the alignment
  // and rotation written below if it landed afterwards. FlipHorizontally and
  // FlipVertically toggle rather than set, so a second pass over the same hang
  // would silently un-flip the image; hence the token guard.
  const hpAppliedTokenRef = useRef(null);
  useEffect(() => {
    if (!hpLoading || !viewportLoaded || !hpSeriesDataLoaded) return;
    if (!viewportCameraSettled) return;
    if (!viewportHpLayout || viewportHpLayout.size === 0) return;
    if (hpAppliedTokenRef.current === hpApplyToken) return;
    hpAppliedTokenRef.current = hpApplyToken;
    applyViewportLayout(viewportIndex, hpApplyToken);
  }, [
    viewportHpLayout,
    hpLoading,
    viewportLoaded,
    hpSeriesDataLoaded,
    viewportCameraSettled,
    hpApplyToken,
  ]);

  /**
   * Carry out an alignment lock for this viewport, and keep carrying it out.
   *
   * Re-asserting the alignment is the point of re-running on each completed
   * load: a series dropped into a locked viewport comes up fitted and centred
   * like any other, and the lock has to hold the edge the protocol (or the
   * radiologist) asked for, not wherever the new image happened to land.
   *
   * The zoom is measured before and restored after, because writing an alignment
   * refits the camera. Read at this point that is whatever the viewport is
   * actually at - the protocol's customScaleValue when a hang has just finished,
   * the new series' own fit after a drop, the radiologist's zoom when they lock a
   * viewport by hand - so one line covers all three.
   *
   * It waits out hpLoading rather than racing applyViewportLayout, which is
   * writing the same camera behind the curtain; once the hang is final this runs
   * over the top of it and lands on the same place.
   */
  const alignmentLock = alignmentLocks?.get(viewportIndex);
  useEffect(() => {
    if (!alignmentLock || !viewportElement || !viewportLoaded || hpLoading) return;

    let cancelled = false;
    let releaseLock = null;

    (async () => {
      try {
        const rotation = await getViewportRotation(viewportIndex);
        const zoomFactor = await getViewportScaleFactor(viewportIndex);
        await setStackPosition(viewportIndex, alignmentLock, rotation);
        await new Promise((resolve) => setTimeout(resolve, HP_CAMERA_SETTLE_MS));
        if (cancelled) return;

        if (zoomFactor) {
          await applyViewportScale(viewportIndex, zoomFactor, alignmentLock);
        }
        if (cancelled) return;

        releaseLock = await startAlignmentLock(viewportIndex, alignmentLock);
        if (cancelled) {
          releaseLock?.();
          releaseLock = null;
        }
      } catch (error) {
        console.warn(
          "Alignment lock: could not pin the viewport",
          viewportIndex,
          error
        );
      }
    })();

    return () => {
      cancelled = true;
      releaseLock?.();
    };
  }, [
    alignmentLock,
    viewportElement,
    viewportLoaded,
    hpLoading,
    viewportLoadEpoch,
    viewportIndex,
  ]);

  //start stop prefetch
  const startPrefetching = async () => {
    if (viewportModality != "SR") {
      await prefetchData(viewportSeriesData[viewportIndex].thumbnailIndex);
    }
  };

  const onChange = useCallback((event) => {
    const intValue = parseInt(event.target.value, 10);
    lastUserScrollSourceRef.current = {
      viewportIndex,
      timestamp: Date.now(),
    };
    // Guard: only proceed if viewportSeriesData and image list are valid
    const seriesData = viewportSeriesData?.[viewportIndex];
    const seriesImageIds = seriesData?.stack?.thumbnailImageIds;
    if (!Array.isArray(seriesImageIds) || seriesImageIds.length === 0) {
      // Data not ready, do nothing
      return;
    }
    const safeTargetIndex = Math.max(0, Math.min(intValue, seriesImageIds.length - 1));
    const imageId = seriesImageIds[safeTargetIndex];
    if (imageId && cache.getImage(imageId)) {
      clearScrollImageLoader();
      updateViewport(viewportIndex, intValue);
      signalSyncTargetLoaders(intValue);
    } else {
      setScrollLoaderForIndex(intValue, null, true);
      updateViewport(viewportIndex, intValue);
      signalSyncTargetLoaders(intValue);
    }
  }, [viewportIndex, signalSyncTargetLoaders, setScrollLoaderForIndex, viewportSeriesData, clearScrollImageLoader]);

  const playCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.playClip(element, { framesPerSecond: cINEFramesPerSecond });
  };

  const pauseCINE = async () => {
    const element = $("#viewport_" + viewportIndex).find("#viewportEntry")[0];
    cine.stopClip(element);
  };

  const isActiveOrFullScreenViewport = activeViewportIndex === viewportIndex || viewportDoubleClickIndex === viewportIndex;

  useEffect(() => {
    if (isActiveOrFullScreenViewport) {
      if (isCineEnabled) {
        if (viewportLevelCINEEnabled) {
          playCINE();
        } else {
          pauseCINE();
        }
      } else {
        setViewportLevelCINEEnabled(true);
        pauseCINE();
      }
    } else {
      if (viewportLevelCINEEnabled) {
        pauseCINE();
        setViewportLevelCINEEnabled(true);
      }
    }
  }, [
    activeViewportIndex,
    viewportDoubleClickIndex,
    isCineEnabled,
    cINEFramesPerSecond,
    viewportLevelCINEEnabled,
  ]);

  useEffect(() => {
    setViewportLevelCINEEnabled(false);
  }, [activeThumbnailIndex]);

  // const onKeyPress = async (event) => {
  //   const keyCode = event.which;

  //   switch (keyCode) {

  //     case 27: //ESC
  //       if (activeTool === DEFAULT_TOOL) {
  //         break;
  //       }
  //       setPreviousActiveTool(activeTool);
  //       // setActiveTool(DEFAULT_TOOL);
  //       handleDefaultToolChange();
  //       break;
  //     case 73: //i -- INVERT
  //       setInvert(activeViewportIndex);
  //       break;
  //     case 72: //h -- HORIZONTAL FLIP
  //       FlipHorizontally(activeViewportIndex);
  //       break;
  //     case 86: //v -- VERTICAL FLIP
  //       FlipVertically(activeViewportIndex);
  //       break;
  //     case 48: //NORMAL WW WC
  //       resetVOILUTRange(activeViewportIndex, initialVOIRange);
  //       break;
  //     case 49: //CT ABDOMEN
  //       setVOILUTRange(activeViewportIndex, 400, 60);
  //       break;
  //     case 50: //CT ANGIO
  //       setVOILUTRange(activeViewportIndex, 600, 300);
  //       break;
  //     case 51: //CT BONE
  //       setVOILUTRange(activeViewportIndex, 1500, 300);
  //       break;
  //     case 52: //CT BRAIN
  //       setVOILUTRange(activeViewportIndex, 80, 40);
  //       break;
  //     case 53: //CT CHEST
  //       setVOILUTRange(activeViewportIndex, 400, 40);
  //       break;
  //     case 54: //CT LUNGS
  //       setVOILUTRange(activeViewportIndex, 1500, -400);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  useEffect(() => {
    // if (activeTool === DEFAULT_TOOL) {
    //   return;
    // }
    if (!viewportLoaded) {
      return;
    }
    
    setToolOnActiveViewport(
      viewportIndex,
      activeTool,
      previousActiveTool,
      activeViewportIndex,
      mouseButtonToolAssignments
    );
  }, [activeViewportIndex, activeThumbnailIndex]);

  const isRotatingRef = useRef(false);
  const startAngleRef = useRef(0);
  const startRotationRef = useRef(0);

  const getAngleFromCenter = (e, element) => {
    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    return Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);
  };

  useEffect(() => {
    if (activeTool !== "FreeRotate" || !viewportElement) return;

    // while FreeRotate is active, disable native touch gestures on the
    // viewport. Without this the browser hijacks the touch-drag as a scroll/zoom gesture and
    // fires pointercancel mid-drag, so rotation only advances in steps (user had to tap
    // repeatedly). touch-action:none hands us the full continuous drag for smooth rotation.
    const prevTouchAction = viewportElement.style.touchAction;
    viewportElement.style.touchAction = "none";

    // passive:false so preventDefault() can suppress any residual browser gesture handling.
    const listenerOpts = { capture: true, passive: false };

    const handlePointerDown = async (e) => {
      if (e.button !== 0) return;
      isRotatingRef.current = true;
      try { viewportElement.setPointerCapture(e.pointerId); } catch { /* ignore */ }
      startAngleRef.current = getAngleFromCenter(e, viewportElement);
      const currentRotation = await getViewportRotation(viewportIndex);
      startRotationRef.current = currentRotation;
      e.preventDefault();
      e.stopPropagation();
    };

    const handlePointerMove = async (e) => {
      if (!isRotatingRef.current) return;
      const currentAngle = getAngleFromCenter(e, viewportElement);
      const delta = currentAngle - startAngleRef.current;
      const newRotation = ((startRotationRef.current + delta) % 360 + 360) % 360;
      const rounded = Math.round(newRotation);
      setViewportRotation(rounded);
      await setRotationAbsolute(viewportIndex, rounded);
      e.preventDefault();
      e.stopPropagation();
    };

    const handlePointerUp = (e) => {
      isRotatingRef.current = false;
      try { viewportElement.releasePointerCapture(e.pointerId); } catch { /* ignore */ }
    };

    viewportElement.addEventListener("pointerdown", handlePointerDown, listenerOpts);
    viewportElement.addEventListener("pointermove", handlePointerMove, listenerOpts);
    viewportElement.addEventListener("pointerup", handlePointerUp, listenerOpts);
    viewportElement.addEventListener("pointercancel", handlePointerUp, listenerOpts);

    return () => {
      viewportElement.style.touchAction = prevTouchAction;
      viewportElement.removeEventListener("pointerdown", handlePointerDown, listenerOpts);
      viewportElement.removeEventListener("pointermove", handlePointerMove, listenerOpts);
      viewportElement.removeEventListener("pointerup", handlePointerUp, listenerOpts);
      viewportElement.removeEventListener("pointercancel", handlePointerUp, listenerOpts);
    };
  }, [activeTool, viewportElement, viewportIndex]);

  useEffect(() => {
    if (activeTool === "FreeRotate" && viewportLoaded) {
      getViewportRotation(viewportIndex)
        .then((r) => setViewportRotation(r || 0))
        .catch(() => setViewportRotation(0));
    }
  }, [activeTool, viewportLoaded]);

  useEffect(() => {
    if ((viewportIndex === 0 && viewportLoaded) || (hpLoading && viewportLoaded)) {
      setTimeout(async () => {
        setToolOnActiveViewport(
          viewportIndex,
          activeTool,
          previousActiveTool,
          activeViewportIndex,
          mouseButtonToolAssignments
        );
      }, 500); 
    }
  }, [viewportLoaded, hpLoading, mouseButtonToolAssignments]);

  useEffect(() => {
    if (!viewportLoaded || !isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    enableStackScrollSync(
      activeViewportIndex,
      syncMode,
      viewportSeriesData,
      linkedViewports.length > 0 ? linkedViewports : null
    );
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportLoaded,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (!viewportLoaded || viewportLoaderRunning) {
      return;
    }

    if (!isSynchronizedEnabled || syncMode === SYNC_MODES.DISABLED) {
      return;
    }

    // When a dropped/selected series finishes loading, register sync again so
    // newly ready targets participate immediately (no delayed first sync).
    lastSignaledTargetIndexRef.current = {};
    enableStackScrollSync(
      activeViewportIndex,
      syncMode,
      viewportSeriesData,
      linkedViewports.length > 0 ? linkedViewports : null
    );
  }, [
    activeViewportIndex,
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportLoaded,
    viewportLoaderRunning,
    viewportSeriesData,
  ]);

  useEffect(() => {
    if (isSynchronizedEnabled && SYNC_EXCLUDED_MODALITIES.includes(viewportModality)) {
      disableStackScrollSync();
      setIsSynchronizedEnabled(false);
    }
  }, [viewportModality]);

  // Action propagation (WW/WL, zoom, pan) at the scope the hanging protocol asked
  // for. Gated on hpLoading as well as the load flags: a protocol writes its own
  // windowing and alignment into each viewport as it hangs, and registering while
  // that is in flight would let the first of those writes flatten every other
  // viewport. Registration itself changes nothing — it only takes effect on the
  // next VOI/camera event, which is the radiologist's.
  //
  // syncMode and isSynchronizedEnabled are dependencies because the LINKED scope
  // is defined by the stack-scroll groups: when those regroup, this must rebuild.
  // alignmentLocks is one too: pan does not propagate into a locked viewport, so
  // taking a lock off (the padlock) has to put that viewport back in the pan
  // group, and hanging a protocol that locks one has to take it out.
  useEffect(() => {
    if (!viewportLoaded || viewportLoaderRunning || hpLoading) {
      return;
    }

    if (!actionSyncMode || actionSyncMode === ACTION_SYNC_MODES.DISABLED) {
      disableActionSync();
      return;
    }

    enableActionSync(
      activeViewportIndex,
      actionSyncMode,
      viewportSeriesData,
      linkedViewports.length > 0 ? linkedViewports : null,
      alignmentLocks ? [...alignmentLocks.keys()] : []
    );
  }, [
    actionSyncMode,
    activeViewportIndex,
    alignmentLocks,
    hpLoading,
    isSynchronizedEnabled,
    linkedViewports,
    syncMode,
    viewportLoaded,
    viewportLoaderRunning,
    viewportSeriesData,
  ]);

  const setActive = (
    updateFromViewportSeriesData = true,
    droppedSeriesData = null
  ) => {
    if (isSynchronizedEnabled) {
      enableStackScrollSync(
        viewportIndex,
        syncMode,
        viewportSeriesData,
        linkedViewports.length > 0 ? linkedViewports : null
      );
    } else {
      disableStackScrollSync();
    }
    setActiveViewportModality(viewportModality);
    changeActiveViewportIndex(viewportIndex);
    if (viewportLoaded || droppedSeriesData) {
      const resolvedThumbnailIndex =
        droppedSeriesData?.thumbnailIndex ??
        viewportSeriesData[viewportIndex].thumbnailIndex;
      changeActiveThumbnailIndex(resolvedThumbnailIndex);
      if(updateFromViewportSeriesData) {

        setActiveModality(viewportSeriesData[viewportIndex].modality);
        let studyIdString = viewportSeriesData[viewportIndex].study;
        let studyIdInteger = parseInt(studyIdString, 10);
        setActiveStudyId(studyIdInteger);
      } else if (droppedSeriesData) {
        setActiveModality(droppedSeriesData.modality);
        const droppedStudyId = parseInt(droppedSeriesData.studyId, 10);
        if (!Number.isNaN(droppedStudyId)) {
          setActiveStudyId(droppedStudyId);
        }
      }
    } else {
      changeActiveThumbnailIndex(undefined);
    }

    if(boundingBoxAdding && boundingBoxAdding === "disabled" && activeTool === 'RectangleROI' && editWarning.success){
      handleRemoveWarning();
    }else{
      setBoundingBoxAdding("disabled");
    }    
  };

  const updateZoomedInViewportState = async () => {
    const viewport = await getViewport(viewportIndex);
    updateViewportProperties(viewportIndex, viewport);
  };

  const initializeAllViewportState = async () => {
    for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
      const viewport = await getViewport(viewportIndex);
      updateViewportProperties(viewportIndex, viewport);
    }
  };

  const showLargeImage = async () => {
    if(viewportLoaded && !isCineEnabled){
      if(!viewportOldState.largeImage){
        await initializeAllViewportState();
      }else{
        await updateZoomedInViewportState();
      }


    const activeViewport = await getViewport(activeViewportIndex);
    updateViewportProperties(activeViewportIndex, activeViewport);
        
      setViewportOldState((prevState) => ({
        ...prevState,
        viewportIndex: viewportIndex,
        // activeImageIndex: currentImage,
        isDoubleClicked: true,
        largeImage: !prevState.largeImage,
      })); 
    }
  };

  useEffect(() => {
    if (viewportOldState.isDoubleClicked && viewportOldState.viewportIndex === viewportIndex) {
      if (viewportOldState.largeImage) {

        const viewportMap = new Map();

        for (let viewportIndex = 0; viewportIndex < VIEWPORT_COLUMN * VIEWPORT_ROW; viewportIndex++) {
            viewportMap.set(viewportIndex, false);
        }
        
        const allViewportOldStatus = Object.fromEntries(viewportMap);

        setViewportOldState((prevState) => ({
          ...prevState,
          reportMenu: reportMenu,
          seriesMenu: seriesMenu,
          showPathologyOptions: showPathologyOptions,
          viewportRow: viewportRow,
          viewportColumn: viewportColumn,
          isDoubleClicked: true,
          activeViewportIndex: activeViewportIndex,
          activeThumbnailIndex: viewportSeriesData[viewportIndex].thumbnailIndex,
          allViewportOldStatus: allViewportOldStatus,
          loadOldViewportStatus: true,
          viewportSeriesData: viewportSeriesData
        }));

        setReportMenu(false);
        setSeriesMenu(false);
       // setShowTopBar(false);
       // setShowSharedTopBar(false);
        setShowPathologyOptions(false);
        // setViewportRow(1);
        // setViewportColumn(1);
        setViewportDoubleClickIndex(viewportIndex);
        setViewportDoubleClickIndexConst(viewportIndex);
        
      } else {
        setReportMenu(viewportOldState.reportMenu);
        setSeriesMenu(viewportOldState.seriesMenu);
        setShowTopBar(true);
        setShowSharedTopBar(true);
        setShowPathologyOptions(viewportOldState.showPathologyOptions);
        // setViewportRow(viewportOldState.viewportRow);
        // setViewportColumn(viewportOldState.viewportColumn);
        setViewportOldState((prevState) => ({
          ...prevState,
          isDoubleClicked: false,
        }));
        setViewportDoubleClickIndex(-1);
        setViewportDoubleClickIndexConst(-1);

        setTimeout(async () => {
          await updateZoomedInViewportState();
          await resizeViewport();
        }, 350);
      }
    }
  }, [viewportOldState.largeImage, viewportOldState.viewportIndex]);

  useEffect(() =>{
    if(viewportDoubleClickIndex  === viewportIndex) {
      setTimeout(async () => {
        await resizeViewport();
        await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
        setViewerOpacity(1);
      }, 350);
    }
  }, [viewportDoubleClickIndex]);

  useEffect(() => {
    const handleDoubleClickReturn = async () => {
      if (viewportOldState && 
        viewportOldState.allViewportOldStatus && 
        !viewportOldState.allViewportOldStatus[viewportIndex] &&
        !viewportOldState.isDoubleClicked) {
        
        setViewportOldState((prevState) => {
          const updatedViewportStatus = { ...prevState.allViewportOldStatus };
          updatedViewportStatus[viewportIndex] = true;
          return {
            ...prevState,
            allViewportOldStatus: updatedViewportStatus,
          };
        });

        setTimeout(async () => {
          await resizeViewport();
          await applyViewportStates(viewportIndex, viewportStates[viewportIndex]);
          setViewerOpacity(1);
        }, 350);
      }
    };
    
    handleDoubleClickReturn();
  }, [viewportOldState]);

  useEffect(() => {
    const sbHeight = `${elementRef.current.clientHeight - 23}px`;
    setScrollbarHeight(() => {
      return sbHeight;
    });
  }, [viewportRow, viewportColumn, viewportElements]);

  useEffect(() => {
    if (activeViewportIndex === viewportIndex) {
      changeActiveThumbnailIndex(
        viewportSeriesData[viewportIndex].thumbnailIndex
      );
    }
  }, [viewportSeriesData]);

  const updateOriginalImageState = () => {
    resetOriginalImageState(originalImageActiveState, activeViewportIndex, setOriginalImageActiveState);
  };

  const handleDrop = async (e) => {
    const seriesData = extractSeriesDataFromDragEvent(e, viewportIndex);
    const nextViewportSeriesData = viewportSeriesData.map((data, i) => {
      if (i !== viewportIndex) return data;
      const { studyId, ...rest } = seriesData;
      return {
        ...rest,
        study: studyId,
      };
    });

    changeActiveThumbnailIndex(seriesData.thumbnailIndex);
    changeViewportSeriesDataUpdated(seriesData);
    setActive(false, seriesData);
    updateOriginalImageState();

    await loadSeriesIntoViewport(
      seriesData.thumbnailIndex,
      viewportIndex,
      seriesData.stack,
      {
        heatmapStack: seriesData.heatmapStack,
        outlineStack: seriesData.outlineStack,
        modality: seriesData.modality,
      }
    );

    if (isSynchronizedEnabled && syncMode !== SYNC_MODES.DISABLED) {
      enableStackScrollSync(
        viewportIndex,
        syncMode,
        nextViewportSeriesData,
        linkedViewports.length > 0 ? linkedViewports : null
      );
    }

    // Re-toggle reference lines after drop so the source viewport is
    // re-evaluated (e.g. if a topogram was dropped into the active viewport,
    // the source should switch to a multi-slice viewport instead).
    if (isReferenceLinesEnabled) {
      toggleReferenceLines(isReferenceLinesEnabled, activeViewportIndex);
    }

    setDragEvent(false);
    if (viewportElement) {
      viewportElement.focus();
      viewportElement.tabIndex = 0;
    }
  };

  useEffect(() => {
    const updateVOI = (event) => {
      const { range } = event.detail;

      if (!range) {
        return;
      }

      const { lower, upper } = range;
      const { windowWidth, windowCenter } = utilities.windowLevel.toWindowLevel(
        lower,
        upper
      );

      setVOI({
        windowWidth: windowWidth,
        windowCenter: windowCenter,
      });

      // A VOI change NOT from our own PR apply is the user windowing — record it as the
      // user's baseline so non-PR frames keep the user's own view (Bug 2).
      if (!isProgrammaticViewportChange()) {
        captureUserBaseline();
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(Enums.Events.VOI_MODIFIED, updateVOI);

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.VOI_MODIFIED,
          updateVOI
        );
      };
    }
  }, [viewportElement]);

  useEffect(() => {
    const cameraModifiedLister = async (event) => {
      // A camera change (zoom/pan) NOT from our own PR apply means the user is driving
      // the view — record it as the user's baseline so non-PR frames keep it (Bug 2).
      if (!isProgrammaticViewportChange()) {
        captureUserBaseline();
      }
      try {
        const m = await updateOrientationMarkers(
          event,
          "viewport_" + activeViewportIndex
        );
        getInitialZoom(viewportIndex, setScale, event);
        setMarkers(m);
      } catch (error) {
        console.error(error);
        return;
      }
    };

    if (viewportElement !== null) {
      viewportElement?.addEventListener(
        Enums.Events.CAMERA_MODIFIED,
        cameraModifiedLister
      );

      return () => {
        viewportElement?.removeEventListener(
          Enums.Events.CAMERA_MODIFIED,
          cameraModifiedLister
        );
      };
    }
  }, [viewportElement]);

  useEffect(() =>{
    // DOC shares the SR path here: both hide the cornerstone canvas, so both
    // need the resize that runs when the viewport returns to an image series.
    if(activeModality === 'SR' || activeModality === 'DOC'){
      setIsSrSelected(true);
    }
  },[activeModality]);
  
  useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          performResize();
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);

  /*useEffect(() =>{
    const handleSrChanged = async () => {
      if(isSrSelected){
        setIsSrSelected(false);
        setTimeout(async () => {
          await resetViewPlaneOfCamera(viewportIndex);
          setViewportFocusCalled(false);
          setTimeout(async () => {
            await resetViewPlaneOfCamera(viewportIndex);
            setViewportFocusCalled(false);
          }, 100);
        }, 100);
      }
    }
      handleSrChanged();
  },[activeThumbnailIndex]);*/

  //this is temporary hack added to resolve the image displaying as a line issue after cornerstone upgraded to 2.0
  useEffect(() => {
    const loadSecondTime = async () => {
        if(viewportLoaded && viewportRendered){
          if(!viewportFocusCalled) {
            setViewportFocusCalled(true);

            // Reset/resize first to fix the "image as a line" Cornerstone 2.0 bug,
            // then await the second load so its applyPRToViewport runs last and
            // correctly restores the saved pan/zoom without being overwritten.
            let activeViewport = null;
            try {
              if (isMPRActive) {
                activeViewport = await getMPRViewport(viewportIndex);
              } else {
                activeViewport = await getViewport(viewportIndex);
              }
              activeViewport.resetCamera({
                resetPan: true,
                resetZoom: true,
                resetToCenter: true,
                storeAsInitialCamera: true,
              });
              activeViewport.resize();
              activeViewport.render();

              await handleLoadSecondTime();
            } finally {
              // A hanging protocol writes its alignment/rotation/zoom after this
              // reset, so it waits for this flag - which has to be set even when
              // the reset threw, or the hang would sit behind its curtain
              // waiting on a viewport that is never going to settle.
              setViewportCameraSettled(true);
            }
          };
        }
      }

      loadSecondTime();
  },[viewportLoaded, viewportFocusCalled, viewportRendered]);

  useEffect(() => {
    setToolOnActiveViewport(
      viewportIndex,
      activeTool,
      previousActiveTool,
      activeViewportIndex,
      mouseButtonToolAssignments
    );
  }, [activeTool, mouseButtonToolAssignments]);

  const onDrag = async () => {
    if (activeTool === StackScrollTool.toolName) {
      setCurrentImage(await getCurrentImage(activeViewportIndex));
    }
  };

  // Modalities this viewport presents as a document pane rather than a
  // cornerstone canvas. The canvas stays mounted but hidden (see the container
  // style below) so the cornerstone element is never torn down and re-created.
  const isDocumentViewport =
    viewportModality === "SR" || viewportModality === "DOC";

  const handlePdfDownload = () => {
    if (!pdfDocument?.objectUrl) return;
    const link = document.createElement("a");
    link.href = pdfDocument.objectUrl;
    link.download = buildPdfFileName(pdfDocument.metadata);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handlePdfOpen = () => {
    if (!pdfDocument?.objectUrl) return;
    window.open(pdfDocument.objectUrl, "_blank", "noopener,noreferrer");
  };


  const [impressionRight, setImpressionRight] = useState(10);
  const [impressionBottom, setImpressionBottom] = useState(
    showKeyImageStar ? 75 : 60
  );
  const [impressionTop, setImpressionTop] = useState(0);
  const handleDragStart = () => {
    // if (showCompare) setShowCompare(false);
  };

  const handleDragStop = (event, data) => {
    let { x, y } = data;
    let right = 10 - x;
    let bottom = 20 - y;

    let clientHeight = $("#viewport_" + viewportIndex).height();
    let clientWidth = $("#viewport_" + viewportIndex).width();
    let impressionHeight = clientHeight * 0.4;
    let impressionWidth = clientWidth * 0.4;

    if (right <= impressionWidth) {
      setImpressionRight(right);
    } else {
      setImpressionRight(right - impressionWidth + 10);
    }

    if (bottom + 50 >= impressionHeight) {
      if (showKeyImageStar) {
        setImpressionTop(clientHeight - bottom - 20);
        // setImpressionBottom(bottom - impressionHeight - 25);
        setImpressionBottom(0);
      } else {
        setImpressionTop(clientHeight - bottom - 35);
        // setImpressionBottom(bottom - impressionHeight - 40);
        setImpressionBottom(0);
      }
    } else {
      if (showKeyImageStar) {
        setImpressionTop(0);
        setImpressionBottom(bottom + 55);
      } else {
        setImpressionTop(0);
        setImpressionBottom(bottom + 40);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        impressionRef.current &&
        !impressionRef.current.contains(event.target)
      ) {
        setShowCompare(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  
  // useEffect(() => {
  //   const viewportElement = viewportRef.current;
  //   if (!viewportElement) return;

  //   const handlePointerDown = (event) => {
  //     // console.log("handlePointerDown");
  //     if (event.pointerType === "mouse") { 
  //       isDragging.current = false;

  //       rightClickTimer.current = setTimeout(() => {
  //         rightClickTimer.current = null;
  //       }, rightClickThreshold);
  //     }
  //   };

  //   const handlePointerMove = () => {
  //     // console.log("handlePointerMove");
  //     if (rightClickTimer.current !== null) {
  //       isDragging.current = true;
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   const handlePointerUp = (event) => {
  //     // console.log("handlePointerUp");
  //     if (event.pointerType === "mouse") {
  //       if (rightClickTimer.current !== null && !isDragging.current) {
  //         if(activeTool === "RectangleROI" && disableAddPathology){
  //           handleRemoveWarning();
  //         }
  //       }
  //       clearTimeout(rightClickTimer.current);
  //       rightClickTimer.current = null;
  //     }
  //   };

  //   if(activeTool === "RectangleROI" && disableAddPathology){
  //     viewportElement.addEventListener("pointerdown", handlePointerDown);
  //     viewportElement.addEventListener("pointermove", handlePointerMove);
  //     viewportElement.addEventListener("pointerup", handlePointerUp);
  //   }

  //   return () => {
  //     viewportElement.removeEventListener("pointerdown", handlePointerDown);
  //     viewportElement.removeEventListener("pointermove", handlePointerMove);
  //     viewportElement.removeEventListener("pointerup", handlePointerUp);
  //   };
  // }, [activeTool]);

  // Cornerstone gives every annotation <text> a drop-shadow filter
  // (filter:url(#shadow-svg-layer-…)); lines and arrows don't get one. Once the
  // cloned layer is drawn as an <img>, some browsers drop filtered elements,
  // so the text went missing from the capture while the arrow stayed. The
  // shadow is cosmetic: strip it from the copy only, never the live layer.
  function stripSvgFiltersForCapture(clonedSvg) {
    clonedSvg.querySelectorAll("[style*='filter']").forEach((el) => {
      el.style.removeProperty("filter");
    });
    clonedSvg.querySelectorAll("[filter]").forEach((el) => el.removeAttribute("filter"));
  }

  function convertToBase64(index, callback) {
    let viewport = document.querySelector(`#viewport_${index}`);
    let cornerstoneCanvas = viewport.querySelector("canvas");
    const svgLayer = document.getElementById("svg-layer-viewport_" + index);

    if (!cornerstoneCanvas || !svgLayer) {
        alert("Canvas or SVG layer not found!");
        return;
    }

    const canvasRect = cornerstoneCanvas.getBoundingClientRect();
    const svgRect = svgLayer.getBoundingClientRect();

    const tempCanvas = document.createElement("canvas");
    const ctx = tempCanvas.getContext("2d");

    tempCanvas.width = canvasRect.width;
    tempCanvas.height = canvasRect.height;
  
    ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

      // Clone and scale the SVG
      const clonedSvg = svgLayer.cloneNode(true);
      clonedSvg.setAttribute("width", canvasRect.width);
      clonedSvg.setAttribute("height", canvasRect.height);
      clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
      stripSvgFiltersForCapture(clonedSvg);

      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
      const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = function () {
        const xOffset = svgRect.left - canvasRect.left;
        const yOffset = svgRect.top - canvasRect.top;

        ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

        // Crop out black padding - find bounding box of non-black pixels
        const w = tempCanvas.width;
        const h = tempCanvas.height;
        const imageData = ctx.getImageData(0, 0, w, h);
        const pixels = imageData.data;
        const threshold = 10; // pixel brightness threshold to distinguish from black
        let top = h, left = w, bottom = 0, right = 0;

        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (pixels[i] > threshold || pixels[i + 1] > threshold || pixels[i + 2] > threshold) {
              if (y < top) top = y;
              if (y > bottom) bottom = y;
              if (x < left) left = x;
              if (x > right) right = x;
            }
          }
        }

        if (bottom > top && right > left) {
          const cropW = right - left + 1;
          const cropH = bottom - top + 1;
          const croppedCanvas = document.createElement("canvas");
          croppedCanvas.width = cropW;
          croppedCanvas.height = cropH;
          const croppedCtx = croppedCanvas.getContext("2d");
          croppedCtx.drawImage(tempCanvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
          const finalBase64 = croppedCanvas.toDataURL("image/png");
          if (callback) callback(finalBase64);
        } else {
          // Fallback: no cropping if detection fails
          const finalBase64 = tempCanvas.toDataURL("image/png");
          if (callback) callback(finalBase64);
        }
      };

      img.src = svgDataUrl;
  }

// Function to copy base64 to clipboard
async function copyToClipboard(index) {
  convertToBase64(index, async (base64Image) => {
      try {

          const response = await fetch(base64Image);
          const blob = await response.blob();
          const item = new ClipboardItem({ "image/png": blob });

          await navigator.clipboard.write([item]);
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-capture-button-text"));
          //alert("Image copied to clipboard!");
      } catch (err) {
          console.error("Failed to copy image:", err);
      }
  });
}



function flashViewport(index) {
  const viewport = document.querySelector(`#viewport_${index}`);
  if (!viewport) return;
  const flash = document.createElement("div");
  flash.style.cssText =
    "position:absolute;inset:0;background:#fff;opacity:0.85;pointer-events:none;z-index:9999;border-radius:inherit;transition:opacity 0.4s ease-out;";
  viewport.style.position = "relative";
  viewport.appendChild(flash);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      flash.style.opacity = "0";
    });
  });
  setTimeout(() => flash.remove(), 450);
}

async function handleUploadScDicom(index) {
  // Capturing SC is only allowed on the parent/current study — never on a prior
  // study in the patient viewer. Guard here too (defence in depth) so the
  // aug:request-sc-capture event path and any programmatic trigger are also
  // blocked, not just the hidden button/tile.
  const captureStudy = viewportSeriesData?.[index]?.study;
  if (captureStudy != null && studyParentId != null &&
      String(captureStudy) !== String(studyParentId)) {
    return;
  }
  flashViewport(index);
  setViewportLoaderRunning(true);
  const seriesId = viewportSeriesData[index].stack.seriesId;
  const imageId = viewportSeriesData[index].stack.images[currentImage].id;
  let viewport = document.querySelector(`#viewport_${index}`);
  let cornerstoneCanvas = viewport.querySelector("canvas");
  const svgLayer = document.getElementById("svg-layer-viewport_" + index);

  if (!cornerstoneCanvas || !svgLayer) {
      alert("Canvas or SVG layer not found!");
      return;
  }

  // Clone the SVG to prevent modifications in the viewer
  const clonedSvg = svgLayer.cloneNode(true);

  // Get actual displayed size of canvas & SVG
  const canvasRect = cornerstoneCanvas.getBoundingClientRect();
  const svgRect = svgLayer.getBoundingClientRect();

  // Ensure SVG matches the actual canvas dimensions
  clonedSvg.setAttribute("width", canvasRect.width);
  clonedSvg.setAttribute("height", canvasRect.height);
  clonedSvg.setAttribute("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
  stripSvgFiltersForCapture(clonedSvg);

  // Convert SVG to base64
  const svgData = new XMLSerializer().serializeToString(clonedSvg);
  const svgBase64 = btoa(unescape(encodeURIComponent(svgData)));
  const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

  // Create a new canvas for merging images
  const tempCanvas = document.createElement("canvas");
  const ctx = tempCanvas.getContext("2d");

  // Use the ACTUAL displayed dimensions (not internal ones)
  tempCanvas.width = canvasRect.width;
  tempCanvas.height = canvasRect.height;

  // Draw the DICOM canvas first
  ctx.drawImage(cornerstoneCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

  // Load and draw the SVG overlay
  const img = new Image();
  img.crossOrigin = "anonymous";

  img.onload = async function () {
      // Correcting offset positioning
      const xOffset = svgRect.left - canvasRect.left;
      const yOffset = svgRect.top - canvasRect.top;
      ctx.drawImage(img, xOffset, yOffset, canvasRect.width, canvasRect.height);

      // Crop out black letterbox padding around the image
      const w = tempCanvas.width;
      const h = tempCanvas.height;
      const imageData = ctx.getImageData(0, 0, w, h);
      const pixels = imageData.data;
      const threshold = 10;
      let top = h, left = w, bottom = 0, right = 0;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const i = (y * w + x) * 4;
          if (pixels[i] > threshold || pixels[i + 1] > threshold || pixels[i + 2] > threshold) {
            if (y < top) top = y;
            if (y > bottom) bottom = y;
            if (x < left) left = x;
            if (x > right) right = x;
          }
        }
      }

      let outputCanvas = tempCanvas;
      if (bottom > top && right > left) {
        const cropW = right - left + 1;
        const cropH = bottom - top + 1;
        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = cropW;
        croppedCanvas.height = cropH;
        const croppedCtx = croppedCanvas.getContext("2d");
        croppedCtx.drawImage(tempCanvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
        outputCanvas = croppedCanvas;
      }

      // Convert final merged canvas to Base64
      const base64Data = outputCanvas.toDataURL("image/png").replace(/^data:image\/\w+;base64,/, "");

      // Upload the Base64 image
      try {
          const result = await uploadScDicom(base64Data,imageId);
          setViewportLoaderRunning(false);
          // The SC is ingested into object storage asynchronously, so it isn't renderable yet.
          // Just bump the popup badge and record it as pending; the popup fetches/polls and
          // auto-places it once ingestion completes. No immediate library fetch or placement.
          const newSopUid = result?.data?.data?.sopInstanceUid || result?.data?.sopInstanceUid;
          if (newSopUid && typeof markPendingCapture === "function") {
            markPendingCapture(newSopUid);
          }
          // The capture is never placed on a report at capture time. It simply lands in the SC
          // library; the Images popup decides where it renders (appended at the end of the report
          // by default, or distributed across reports when that flag is unticked). This keeps the
          // basic viewer and the MedDream advanced viewer (which captures server-side via STORESCP)
          // behaving identically.
          showToastv2(TOAST_TYPE.SUCCESS, t("react-sc-dicom.sc-clipboard-copy-button-text"));
          // Poll until the async DICOM ingestion finishes, then merge in just
          // the SC series (upsert — repeat captures replace the shared
          // "SC DICOM" series' stack in place), instead of refetching/rebuilding
          // the whole study structure — that full rebuild is what flashed the
          // viewport on every capture. Not awaited so the upload button
          // re-enables immediately.
          const newSeriesInstanceUid = result?.data?.data?.seriesInstanceUid || result?.data?.seriesInstanceUid;
          if (newSeriesInstanceUid && typeof waitForScSeriesAndMerge === "function") {
            waitForScSeriesAndMerge(newSeriesInstanceUid, { sopInstanceUid: newSopUid }).then((mergeResult) => {
              if (!mergeResult?.success) {
                console.warn("[Viewport] SC DICOM series merge did not complete:", mergeResult);
              }
            });
          }
      } catch (error) {
          setViewportLoaderRunning(false);
          console.error("Upload failed:", error);
      }
  };

  img.src = svgDataUrl;
}

useEffect(() => {
  const listener = (e) => {
    if (e?.detail?.viewportIndex === viewportIndex) {
      handleUploadScDicom(viewportIndex);
    }
  };
  window.addEventListener("aug:request-sc-capture", listener);
  return () => window.removeEventListener("aug:request-sc-capture", listener);
}, [viewportIndex, currentImage, viewportSeriesData]);

// NEW: mobile "Copy to clipboard" support. The mobile toolbar (MobileMoreMenu)
// can't call copyToClipboard() directly because that handler lives here in
// Viewport.jsx. So, mirroring the existing "aug:request-sc-capture" pattern
// above, the mobile tile dispatches an "aug:request-copy" window event carrying
// the active viewportIndex, and the matching viewport handles it here.
useEffect(() => {
  const listener = (e) => {
    if (e?.detail?.viewportIndex === viewportIndex) {
      console.warn("::MOBILE-CAPTURE:: [Viewport] aug:request-copy received", {
        viewportIndex,
      });
      copyToClipboard(viewportIndex);
    }
  };
  window.addEventListener("aug:request-copy", listener);
  return () => window.removeEventListener("aug:request-copy", listener);
}, [viewportIndex, currentImage, viewportSeriesData]);



 return (
    <>
      <div
        className="viewport-parent-container h100 w100"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div
          className="viewport-container h100 w100"
          style={{
            position: isDocumentViewport ? "absolute" : "static",
            opacity: isDocumentViewport ? 0 : 1,
            pointerEvents: isDocumentViewport ? "none" : "auto",
            zIndex: isDocumentViewport ? -1 : "auto",
          }}
          
        >
          {/* {contextMenuOpen.open && (
            <ContextMenu
              mouseEvt={contextMenuOpen.mouseEvt}
              data={contextMenuOpen.data}
            />
          )} */}
  <div>

            </div>
          <div
            id={`viewport_${viewportIndex}`}
            className="cursor-pointer viewport-box h100 w100"
            //onKeyDown={onKeyPress}
            onClick={setActive}
            onDoubleClick={showLargeImage}
            // ref={viewportRef}
          >
           
            <div
              ref={elementRef}
              id="viewportEntry"
              className="h100 w100"
              style={{
                backgroundColor: 'black',
                cursor: activeTool === "FreeRotate" ? "crosshair" : undefined,
              }}
              onDrop={handleDrop}
              onDragOver={(e) => {
                e.preventDefault();
              }}
            ></div>
            <DicomOverlayLayer viewportElement={viewportElement} />
            {(isSpineLabellingActive || spineLabels?.length > 0) && (
              <SpineLabellingTool
                viewportIndex={viewportIndex}
                viewportElement={viewportElement}
              />
            )}

            {hpCurtainDown && (
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  height: "100%",
                  width: "100%",
                  backgroundColor: "black",
                  // Over the image, the DICOM overlay plane and the annotation
                  // layers; under the spinner, which has to stay visible.
                  zIndex: "9998",
                  pointerEvents: "none",
                }}
              />
            )}

            {(viewportLoaderRunning || hpCurtainDown) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                  pointerEvents: "none",
                }}
              >
                <Spinner size={15} />
              </div>
            )}

            {!viewportLoaderRunning && !hpCurtainDown && scrollImageLoadState.loading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  height: "100%",
                  width: "100%",
                  zIndex: "99998",
                  position: "absolute",
                  top: "0",
                  background: "rgba(0, 0, 0, 0.82)",
                  pointerEvents: "none",
                }}
              >
                <Spinner size={12} />
                <span style={{ color: "#fff", fontSize: "11px" }}>
                  {t("studyviewer.scroll-image-loading", "Loading image")}
                </span>
              </div>
            )}

            <ImageScrollbar
              max={imageCount}
              // value={
              //   isSynchronizedEnabled ? synchronizedCurrentImage : currentImage
              // }
              // `currentImage` is already pinned to the OUTER (per-instance)
              // index during cine by the STACK_NEW_IMAGE handlers
              // (getCurrentOuterIndex), and for single-instance multiframe it
              // is left untouched while playing — so it is the correct
              // scrollbar position in every case. The old frozen-ref override
              // captured a stale currentImage (effect dep [viewportIndex]) and
              // snapped the thumb to the top during play.
              value={currentImage}
              onChange={onChange}
              //onKeyPress={onKeyPress}
              height={scrollbarHeight}
              elementRef={elementRef}
            />
            <MultiFrameToolbar viewportIndex={viewportIndex} />
            {showOverlay && viewportLoaded && (
              <>
                {getEnv("REACT_APP_VDC_PLATFORM") === "false" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <MobileOverlay
                      viewportData={viewportSeriesData[viewportIndex]}
                    />
                  )}
                {getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
                  (isMobile || viewportRow > 2 || viewportColumn > 2) && (
                    <>
                      <VDCMobileDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        isVDCMobileViewer={true}
                      />
                    </>
                  )}
                {!isMobile && viewportRow <= 2 && viewportColumn <= 2 && (
                  <div className="viewport-overlay-top-container">
                    <PatientDetails
                      viewportData={viewportSeriesData[viewportIndex]}
                      showForceReinference={showForceReinference}
                      forceReinference={forceReinference}
                      reportDoneStatusState={reportDoneStatusState}
                    />
                    <div className="viewport-overlay-right-column">
                      <StudyDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        viewportIndex={viewportIndex}
                      />
                      <SCDICOMDetails
                        viewportData={viewportSeriesData[viewportIndex]}
                        viewportIndex={viewportIndex}
                        copyToClipboard={copyToClipboard}
                        handleUploadScDicom={handleUploadScDicom}
                        //added for quality flag
                        currentImage={currentImage}
                      />
                      <ViewportSyncIndicator
                        viewportIndex={viewportIndex}
                        viewportModality={viewportModality}
                        lastSignaledTargetIndexRef={lastSignaledTargetIndexRef}
                      />
                      <ViewportAlignmentLockIndicator
                        viewportIndex={viewportIndex}
                      />
                    </div>
                  </div>
                )}

                {/* the desktop right column (above) is hidden on mobile,
                    so the Link Series icon never showed. Render just the sync
                    indicator on mobile, anchored top-right on the viewport. It
                    returns null unless Synchronize is enabled, so it only appears
                    when sync is on — same behaviour/conditions as desktop. */}
                {isMobile && (
                  <div
                    style={{
                      position: "absolute",
                      top: "44px",
                      right: "25px",
                      width: "25px",
                      display: "flex",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "auto",
                    }}
                  >
                    <ViewportSyncIndicator
                      viewportIndex={viewportIndex}
                      viewportModality={viewportModality}
                      lastSignaledTargetIndexRef={lastSignaledTargetIndexRef}
                    />
                    <ViewportAlignmentLockIndicator
                      viewportIndex={viewportIndex}
                    />
                  </div>
                )}

                {/* OLD: this SCDICOMDetails rendered unconditionally, so the
                     Copy / Secondary-Capture / Save-PR / Mark-KO buttons also
                     floated over the image on mobile.
                    NEW: on mobile these 4 actions live in the bottom "More"
                     menu (MobileMoreMenu) instead, so hide this desktop
                     viewport-overlay copy on mobile to avoid duplication.
                     Desktop is unchanged (isMobile === false → still renders).
                    Layouts with more than 2 rows/columns skip the
                     viewport-overlay-top-container block above (it renders
                     MobileOverlay/VDCMobileDetails instead), which also
                     dropped the right-column SCDICOMDetails. Render this
                     fallback copy only for that case, absolutely positioned
                     (viewport-overlay-sc-dicom-floating) so it isn't clipped
                     by the viewport's overflow:hidden — otherwise it renders
                     in normal document flow below the canvas and is invisible. */}
                {!isMobile && (viewportRow > 2 || viewportColumn > 2) && (
                  <div className="viewport-overlay-sc-dicom-floating">
                    <SCDICOMDetails
                      viewportData={viewportSeriesData[viewportIndex]}
                      viewportIndex={viewportIndex}
                      copyToClipboard={copyToClipboard}
                      handleUploadScDicom={handleUploadScDicom}
                    />
                    {/* Grids this size skip the right column above, and a 2x3 or
                        3x3 protocol is exactly where a locked viewport is likely
                        to be — so the padlock has to be reachable here too. */}
                    <ViewportAlignmentLockIndicator
                      viewportIndex={viewportIndex}
                    />
                  </div>
                )}
                <SeriesDetails
                  viewportData={viewportSeriesData[viewportIndex]}
                  // currentImage={
                  //   isSynchronizedEnabled
                  //     ? synchronizedCurrentImage
                  //     : currentImage
                  // }
                  currentImage={currentImage}
                  totalImage={imageCount}
                />
                <CalibrationBadge
                  viewportIndex={viewportIndex}
                  currentImage={currentImage}
                />
                {showCompare && isCompareActive && (
                  <div
                    // ref={impressionRef}
                    className="viewer-tool-more-dropdown"
                    style={{
                      position: "absolute",
                      height: "fit-content",
                      maxHeight: "40%",
                      width: "40%",
                      padding: "10px 10px 0px 10px",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "10px",
                      bottom: `${
                        impressionBottom === 0
                          ? "unset"
                          : impressionBottom + "px"
                      }`,
                      right: `${impressionRight}px`,
                      top: `${
                        impressionTop === 0 ? "unset" : impressionTop + "px"
                      }`,
                    }}
                  >
                    <div
                      id={`impression-text-viewport-${viewportIndex}`}
                      className="modal-scroll"
                      style={{
                        flex: 1,
                        overflowY: "auto",
                        minHeight: 0,
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          impressions[
                            "study_" + viewportSeriesData[viewportIndex].study
                          ]?.impressionText,
                      }}
                    >
                      {/* {
                        impressions[
                          "study_" + viewportSeriesData[viewportIndex].study
                        ]?.impressionText
                      } */}
                    </div>
                    <div
                      className="cursor-pointer"
                      style={{
                        flexShrink: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingBottom: "10px",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        var r = document.createRange();
                        r.selectNode(
                          document.getElementById(
                            `impression-text-viewport-${viewportIndex}`
                          )
                        );
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(r);
                        document.execCommand("copy");
                        window.getSelection().removeAllRanges();
                        // let copyText = document.getElementById(
                        //   `impression-text-viewport-${viewportIndex}`
                        // );
                        // navigator.clipboard.writeText(copyText.innerHTML);
                        showToastv2(TOAST_TYPE.SUCCESS, "Copied to clipboard!");
                      }}
                    >
                      <Copy />
                    </div>
                  </div>
                )}
                {isCompareActive && (
                  <Draggable
                    bounds="parent"
                    onStop={handleDragStop}
                    onStart={handleDragStart}
                    offsetParent={viewportElement}
                    nodeRef={draggableRef}
                  >
                    <div
                      ref={draggableRef}
                      style={{
                        position: "absolute",
                        bottom: showKeyImageStar ? "35px" : "20px",
                        right: "50px",
                      }}
                      onClick={() => {
                        setShowCompare((prev) => !prev);
                      }}
                      onMouseEnter={() => setImpressionHover(true)}
                      onMouseLeave={() => setImpressionHover(false)}
                    >
                      <Impression
                        color={
                          showCompare || impressionHover
                            ? theme.palette.activeTool
                            : theme.palette.inactiveTool
                        }
                      />
                    </div>
                  </Draggable>
                )}
                <ViewportNavWidget
                  viewportIndex={viewportIndex}
                  currentImageIndex={currentImage}
                  viewportLoaded={viewportLoaded}
                  priors={priors}
                  prAppliedCount={prAppliedCount}
                  currentStack={
                    viewportSeriesData[viewportIndex]?.stack?.modality !== "PR" &&
                    viewportSeriesData[viewportIndex]?.stack?.modality !== "SR"
                      ? viewportSeriesData[viewportIndex]?.stack
                      : null
                  }
                  slicePRItems={getSlicePRItems()}
                  sliceKOItems={(() => {
                    const all = getAllCachedKOData();
                    if (!currentSopUID) return [];
                    const matched = all.filter((ko) =>
                      ko.referencedSOPInstanceUIDs?.some(
                        (u) => u?.trim() === currentSopUID
                      ),
                    );
                    return matched.map((ko) => ({
                      title:       ko.title,
                      description: ko.description,
                      creatorName: ko.creatorName,
                      date:        ko.creationDate,
                    }));
                  })()}
                  onPRToggle={handlePRToggle}
                  onPRToggleAll={handlePRToggleAll}
                  prItemsLoading={prItemsLoading}
                />
              {  <DICOMDetails
                  voi={voi}
                  scale={scale}
                  showKeyImageStar={showKeyImageStar}
                  rotation={activeTool === "FreeRotate" ? viewportRotation : null}
                />  }
                <OrientationMarkers markers={markers} />



                {editWarning.show &&
                  viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MarkWarning
                      success={editWarning.success}
                      handleRemoveWarning={handleRemoveWarning}
                      pathalogyName={editWarning.name}
                      backgroundColor={editWarning.color}
                      id={editWarning.id}
                    />
                  )}
                  {/* {
                  enableLlmReport && isAgenticTab && isImageAllowedToLLM(studyModality, studyDescription) && viewportSeriesData[viewportIndex].study == studyParentId && (
                    <MaskImage
                      show={maskingConfirm.show}
                      success={maskingConfirm.success}
                      backgroundColor={maskingConfirm.color}
                      maskImages = {maskImages}
                      currentImage= {currentImage}
                      viewportIndex = {viewportIndex}
                      activeThumbnailIndex= {viewportSeriesData[viewportIndex].thumbnailIndex}
                      id={maskingConfirm.id}
                    />
                  )} */}
              </>
            )}
            {isCineEnabled && (activeViewportIndex === viewportIndex || viewportDoubleClickIndex === viewportIndex) && (
              <>
                <div className="viewport-cine-container" style={!isMobile && window.innerHeight > window.innerWidth ? { bottom: "60px" } : undefined}>
                  <div className="viewport-cine-box">
                    <span
                      className="viewport-cine-button"
                      style={{ marginRight: "10px" }}
                      onClick={() =>
                        setViewportLevelCINEEnabled(!viewportLevelCINEEnabled)
                      }
                    >
                      {viewportLevelCINEEnabled ? (
                        <CINEPauseSmall />
                      ) : (
                        <CINEPlaySmall />
                      )}
                    </span>
                    <span
                      className={`viewport-cine-button ${
                        cINEFramesPerSecond === 1
                          ? "viewport-cine-button-disabled"
                          : ""
                      }`}
                      onClick={() => {
                        if (cINEFramesPerSecond !== 1) {
                          setCINEFramesPerSecond(cINEFramesPerSecond - 1);
                        }
                      }}
                    >
                      {" "}
                      <CINEMinus />{" "}
                    </span>
                    <span style={{color:"#ffffff"}}> {cINEFramesPerSecond} </span>
                    {/* <span className="viewport-cine-framepersecond-button">{cINEFramesPerSecond}</span> */}
                    <span
                      className="viewport-cine-button"
                      onClick={() =>
                        setCINEFramesPerSecond(cINEFramesPerSecond + 1)
                      }
                    >
                      {" "}
                      <CINEPlus />{" "}
                    </span>
                  </div>
                </div>
              </>
            )}
            {!viewportLoaderRunning && !viewportLoaded && (
              <>
                <div
                  className="viewport-empty-message h100 w100"
                  onDrop={handleDrop}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span>{t(isMobile ? "studyviewer.empty-viewport-message-mobile" : "studyviewer.empty-viewport-message")}</span>
                </div>
              </>
            )}
          </div>
        </div>
        {viewportModality === "SR" && (
          <div
            className="viewport-sr-container h100 w100"
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onClick={setActive}
          >
            <div className="viewer-modal-scroll viewport-sr">
              <SRReportView report={srReport} />
            </div>
            {viewportLoaderRunning && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                }}
              >
                <Spinner size={15} />
              </div>
            )}
          </div>
        )}
        {viewportModality === "DOC" && (
          <div
            className="viewport-pdf-container h100 w100"
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onClick={setActive}
          >
            <div className="viewport-pdf-body">
              {pdfError && (
                <div className="viewport-pdf-message">
                  <span className="viewport-overlay-value">
                    {t("studyviewer.pdf-load-error")}
                  </span>
                  <span className="viewport-overlay-key viewport-pdf-message-detail">
                    {pdfError}
                  </span>
                </div>
              )}


              {/* pdf.js rasterises the pages onto canvases. An <iframe> would
                  be simpler but only renders on the desktop: Android Chrome
                  paints a blank frame and iOS WebKit shows page 1 without
                  scrolling, so MobileViewer could never display the document.
                  One renderer for every platform, rather than two paths. */}
              {!pdfError && pdfDocument?.blob && (
                <React.Suspense
                  fallback={
                    <div className="viewport-pdf-message">
                      <Spinner size={15} />
                    </div>
                  }
                >
                  <EncapsulatedPdfViewer
                    blob={pdfDocument.blob}
                    // The PDF fills the pane, so the DICOM tags wrapped around
                    // it have nowhere else to surface. The icon rides in the
                    // viewer's own toolbar rather than a second row of its own.
                    infoSlot={
                      <EncapsulatedDocOverlay metadata={pdfDocument.metadata} />
                    }
                  />
                </React.Suspense>
              )}

            </div>

            {pdfDocument?.objectUrl && (
              <div className="viewport-pdf-actions">
                <span className="viewport-overlay-value viewport-pdf-caption">
                  {pdfDocument.metadata?.title || t("studyviewer.pdf-document")}
                </span>
                <div className="viewport-pdf-action-buttons">
                  <DefaultButton
                    text={t("studyviewer.pdf-download")}
                    iconProps={{ iconName: "Download" }}
                    onClick={handlePdfDownload}
                  />
                  <PrimaryButton
                    text={t("studyviewer.pdf-open")}
                    iconProps={{ iconName: "OpenInNewWindow" }}
                    onClick={handlePdfOpen}
                  />
                </div>
              </div>
            )}

            {(pdfLoading || viewportLoaderRunning) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  zIndex: "99999",
                  position: "absolute",
                  top: "0",
                }}
              >
                <Spinner size={15} />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(Viewport);
